import React, { Component } from "react";
import Navbar     from '../components/Navbar';
import CustomCurrency from '../components/CustomCurrency'; 
import CustomCurrencyNoDecimals from '../components/CustomCurrencyNoDecimals';
import CustomDate from '../components/CustomDate'; 
import CustomSortCode from '../components/CustomSortCode'; 
import { searchCustomFieldsForIndex, peregrine_calc_wrapper, removeMultipleMainApplicants, creditQuickSearch } from '../Utils';
import _ from 'lodash';
import alertify from 'alertifyjs';

// import TermsAndConditions from '../components/TermsAndConditions';
// import { formDataDynamic } from '../data/formDataDynamic';

import { Form } from '@flipbyte/formik-json';

import { boApiSendProposal, convertDate, toTitleCase, getStaff } from '../Utils';
import axios from 'axios';
import $ from 'jquery';
import queryString from 'query-string';
// import 'jquery-mask-plugin';
import { Link, Redirect } from "react-router-dom"; 
import { config } from '../Configurator'

import Loading from '../components/Loading';
import { onSuggestionsClearRequested, getSuggestionValue, renderSuggestion } from '../components/Autocomplete' 
import moment from 'moment';
// import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";

let suggestion_load = null;
let suggestion_load_source = null;

class DynamicFormApiWithSteps extends Component {

    constructor(props) {
        super();
        this.state = { 
            
            the_id: props.match.params.id,
            applicant_id: null,
            customer_reference: null,
            schema_init: false,
            form_name: "",
            data: {},

            // security_arr: [],
            security_selector: null,
            security_selector_set_value_to: null,
            security_count: -1,
            security_autoincrement: 0,

            multicontact_selector: null,
            multicontact_count: -1,
            multicontact_autoincrement: 0,

            // payment_index_updated: null,
            previous_funder: null,
            calc_advance_amount: 0,
            calc_payments: 0,
            calc_payments_2: 0,
            calc_term: 0,
            freq_multiplier: 1,
            frequency: '',
            payment_profile1: 0,
            payment_profile2: 0,

            suggestions_full: null,
            loanRate: 20,
            periodsInAYear: 12, 
            repayment: 0,
            monthlyRepayment: 0,
            key_number: 100,
            step: 1, 
            steps: 1,
            endpoint: "",
            loading: true,
            payment: null,
            total: null,
            totalinterest: null,

            initial: { attributes: {
                'name': '',
                'ba1': null,
                'ba2': null,
                'city': null,
                'county': null,
                'postcode': null,
                'main_contact': '',
                'net_price': 0, // 0
                'vat_2': 0,
                'part_exchange': 0, // 0
                'road_fund_licence': 0,
                'not_vatable_cost': 0,
                "yield": 6, // 6
                'total_cost': 0,
                'total_price': 0,
                'cash_deposit': 0, // 0
                'funding_category': 'Hard Asset',
                'plus_vat_1': 'Yes',
                'part_exchange_plus_vat': 'Yes',
                'dealer_deposit': 0,
                'settlement': 0,
                'road_fund': 0,
                'frequency': 'Monthly',
                'fund_vat': 'No',
                'option_to_purchase_fee': 0.00,
                'doc_fee': 0.00,
                'balloon': 0.00,
                'security_selector': "0",
                'multicontact_selector': "0",
                'guarantor_selector': "0",
                'subsidy': 0.00,
                'non_vatable_cost': 0.00,
                // 'mc1_Guarantor': 'true',
                'payment_profile1': "0", // advance, parse as string
                'payment_profile2': 36,  // 12 // future payments
                'start_date': moment().format("DD-MM-YYYY"),
                'first_payment': moment().add(1, 'M').format("DD-MM-YYYY"),
                'B2B': 'true',
                'caseAssessor28' : 'Last 3 months bank statements of the Borrower \nCompleted Asset & Liability Statement for the Guarantor(s) \nCopy of current buildings insurance schedule for all properties to be charged \nCopy of AST, EPC, Gas and EICR Certificates across all properties charged where applicable \nTrust ID verification of all relevant parties',
                'caseAssessor29' : 'Monthly management accounts to be received before the end of the month following \nMonthly bank statements to be received by [7th] of the following month',
                'caseAssessor36' : '2',
                'CustomFieldValue23': 'Business Finance',
                'SecuirtyValuer__': ' ',
                'SecurityStatus__': 'Live',
                'SecurityStatus__0': 'Live',
                'SecurityStatus__1': 'Live',
                'SecurityStatus__2': 'Live',
                'SecurityStatus__3': 'Live',
                'SecurityStatus__4': 'Live',
                'SecurityStatus__5': 'Live',
                'SecurityStatus__6': 'Live',
                'SecurityStatus__7': 'Live'
             } }
        };
    }

    getData()
    {
        return this.props.data;
    }

    getStorageData()
    {

        let ls = null;
        if(localStorage.getItem('destroy_data')=='false' /* || window.location.hostname=='localhost' */) {
            console.log('recovering data');
            ls = JSON.parse( localStorage.getItem('bo_form_data2') );
        }

        let initial = this.state.initial;
        if(ls) {
            this.setState({initial: {...initial, ...ls}})
        }
    }

    onSuggestionSelected(formikProps, suggestionValue, index, method, b)
    {

        console.log(formikProps);

        let x = this.state.suggestions_full[ b.suggestion.value];

        if(x && typeof x.__type != 'undefined' && x.__type=="OrangeMail.BrightofficeAPI+SourceResult") {
            suggestion_load_source = x;
        } else if(suggestionValue.mode && suggestionValue.mode=='credit_search') {
            let v = (b.suggestion.type==='Ltd') ? b.suggestion.value : "";
            formikProps.setFieldValue("attributes.AltSalutation", v );
        } else {
            let i = b.suggestion.value;
            suggestion_load = this.state.suggestions_full[i];
        }
    }

    onSuggestionsFetchRequested(a,b,c,d)
    {
        let search = (d.value);

        if(search.length<3) {
            return false; 
        }

        if(b.name=="attributes.Source") {

            axios.post(config().base_url + 'GetSource', {
                "UserInfo": {
                    "Username": localStorage.getItem('bo_email'),
                    "Password": localStorage.getItem('bo_password')
                },
                    "pRequest": {
                        "Status": "",
                        "SortType": "Desc",
                        "SortBy": "Ref",
                        "SearchType": "source",
                        "SearchText": search,
                        "RecordStartNo": "1",
                        "RecordEndNo": "10000"
                    }
            })
            .then(response => {

                let ret = [];
                let data = response.data.d.Records;
                let len = data.length;
                if(len>10) len = 10;
                for(let i=0; i<len; i++) {
                    ret.push({ label: data[i].SourceName, value: i  });
                }
                this.setState({suggestions_full: data, suggestions: ret });
                /*
                this.setState({ initial: initial });
                */
            })
            .catch(error => {
                //this.setState({loading: false});
                console.log(error);
            });
    

        } else if(b.name=="attributes.CompanyName" && b.mode && b.mode=='credit_search') {


            creditQuickSearch(search).then((data)=>{

                let ret = [];
                let len = data.length;
                if(len>10) len = 10;
                for(let i=0; i<len; i++) {
                    if(data[i].status==='Active') {
                        ret.push({ label: toTitleCase(data[i].name), 'type': data[i].type, value: data[i].regNo  }); // set key->alt values here 
                    }
                }
                this.setState({suggestions_full: data, suggestions: ret });

            });
        }
        else if(b.name=="attributes.SourceAffiliate") {

            axios.post(config().base_url + 'GetSource', {
                "UserInfo": {
                    "Username": localStorage.getItem('bo_email'),
                    "Password": localStorage.getItem('bo_password')
                },
                    "pRequest": {
                        "Status": "",
                        "SortType": "Desc",
                        "SortBy": "Ref",
                        "SearchType": "sourceaffiliate",
                        "SearchText": search,
                        "RecordStartNo": "1",
                        "RecordEndNo": "10000"
                    }
            })
            .then(response => {

                let ret = [];
                let data = response.data.d.Records;
                let len = data.length;
                if(len>10) len = 10;
                for(let i=0; i<len; i++) {

                    for(let k=0; k<data[i].SourceAffiliates.length; k++) {
                        let nn = data[i].SourceAffiliates[k].SourceAffiliateName;
                        if(nn.toLowerCase().includes(search.toLowerCase())) {
                            ret.push({ label: nn, value: i  });
                        }
                    }

                }
                this.setState({suggestions_full: data, suggestions: ret });
                /*
                this.setState({ initial: initial });
                */
            })
            .catch(error => {
                //this.setState({loading: false});
                console.log(error);
            });
    

        } else {

            axios({
                method: "post",
                url: config().base_url + 'SearchCustomers',
                data: {
                    "SearchParam": search,
                    "UserInfo": {
                        "Username": localStorage.getItem('bo_email'),
                        "Password": localStorage.getItem('bo_password')
                    }
                },
                validateStatus: status => {
                return true;
                }
            })
                .catch(error => {
                console.log(error);
                })
                .then(response => {

                    let return_business = [];
                    let return_individuals = [];
                    let data = response.data.d.Records;
                    let len = data.length;
                    if(len>20) len = 20;
                    for(let i=0; i<len; i++) {
                        if(data[i].CompanyName) {
                            return_business.push({ label: data[i].CompanyName, value: i })    
                        } else {
                            return_individuals.push({ label: (data[i].Firstname ?? '') + " " + (data[i].Surname ?? ''), value: i })
                        }
                    }
                    // console.log(return_individuals);
                    this.setState({suggestions_full: data, suggestions: (return_business.concat(return_individuals))});
                });
        }
    }

    duplicateAndAppendField(element_to_multiply, target, count=null)
    {

        let schema = this.state.data;
        let initial = this.state.initial;
        let o_target = target;
        let to_replicate = element_to_multiply.split('.').reduce((o,i)=>o[i], schema);
        let element_name = element_to_multiply.split('.').slice(-1)[0];
        target = target.split('.').reduce((o,i)=>o[i], schema);
        if(count==null) {
            count = Object.keys(target.elements).length;
            // alert(count);
        }
        let suffix = "__" + count;
        to_replicate = JSON.parse(JSON.stringify( to_replicate )); // deep copy 
        Object.keys(to_replicate.elements).forEach(e => { 
            to_replicate.elements[e].name += suffix; 
        });

        if(o_target==="elements.director_multi_element") {
            initial.attributes['mc1_Guarantor__' + count] = 'true';  
        }

        if(typeof to_replicate.elements.mc1_DateOfBirth != "undefined") {
            to_replicate.elements.mc1_DateOfBirth.renderer = CustomDate;
        }
        
        target.elements[element_name + suffix] = to_replicate; 
        this.setState({data: schema});
    }

    removeDuplicatedField(target)
    {
        let schema = this.state.data;
        target = target.split('.').reduce((o,i)=>o[i], schema);
        let count = Object.keys(target.elements).length;
        if(count>1) {
            let last = null;
            Object.keys(target.elements).forEach(e => { 
                last = e;
            });
            if(last) {
                delete target.elements[last];
            }
        }
        this.setState({data: schema});
    }

    getInitialValues()
    {
        return this.state.initial;
    }

    totalLoanChanged = (e) =>
    {
        this.setState({totalLoan: e.target.value});
        this.calculator();
    }

    loanRateChanged = (e) => {
        this.setState({loanRate: e.target.value});
        this.calculator();
    }

    periodsChanged = (e) => {
        this.setState({periodsInAYear: e.target.value});
        this.calculator();
    }

    loanTermChanged = (e) => {
        this.setState({loanTerm: e.target.value});
        this.calculator();
    }

    calculator = () => {

        let amount = this.state.totalLoan;
        let apr = this.state.loanRate;
        let years = this.state.periodsInAYear;

        let payment = null;
        let total = null;
        let totalinterest = null;

        var principal = amount;
        var interest = apr / 100 / 12;
        var payments = years * 12;
        
        // compute the monthly payment figure
        var x = Math.pow(1 + interest, payments); //Math.pow computes powers
        var monthly = (principal*x*interest)/(x-1);

        payment = monthly.toFixed(2);
        total = (monthly * payments).toFixed(2);
        totalinterest = ((monthly*payments)-principal).toFixed(2);
      
        //let repayment = (totalLoan * Math.pow((loanRate / periodsInAYear) + 1, (loanTerm)),  loanRate / periodsInAYear) / (Math.pow(loanRate / periodsInAYear + 1, (loanTerm)) - 1)
        // monthlyRepayment =  (repayment + TotalFeesNotNeedToIncluedInInterestCalcMonthlyValue)
        // let repayment = 300;
        //let monthlyRepayment = 5;

        this.setState({payment: payment, total: total, totalinterest: totalinterest});
    }

    componentDidMount() {

        let id = this.props.match.params.id;
        let step = this.props.match.params.step;
        let applicant_id = queryString.parse(this.props.location.search).applicant_id;
        let customer_reference = queryString.parse(this.props.location.search).customer_reference;

        if(step) {
            this.setState({ step: step, applicant_id: applicant_id, customer_reference: customer_reference });
        }

        window.onbeforeunload = function() {
            localStorage.setItem('destroy_data', true);
            // return true;
        };

        this.loadData(id, step);
        this.calculator();
    }

    componentDidUpdate = (prevProps) => {
        if(this.props.match.params.id !== prevProps.match.params.id ) {
            this.loadData(this.props.match.params.id, 1);
       };
      };


    loadData(id, step) {

        let the_id = id;
        if(the_id==null) {
            the_id = this.state.the_id;
        } 
        let the_step = step;
        if(the_step==null) {
            the_step = this.state.step;
        }

        // work with local json set
        let local_json_set = '/_json/' + the_id + '/json' + the_step + '.json';

        axios.get(local_json_set)
        .then(response => {
            let s = this.parseLoadedData(response, the_step, the_id);
            this.setState(s, () => {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // for Chrome, Firefox, IE and Opera
    
                this.getStorageData();
                this.loadCase();
                this.loadSecurity(s.data, the_step, the_id);
                this.populateStaffDataDropdowns();

                $('button').attr('disabled', false);

                
    
            });
 
        }).catch(error => {
            console.log("--- Error reading form configuration ---");
            console.log(error);
        });

    }

    populateStaffDataDropdowns() {
        let raw = this.state.data;
        // getStaff data
        let all_get_staff_fields = this.scan(raw, 'getStaff');
        for(let i=0; i<all_get_staff_fields.length; i++) {
            let key = all_get_staff_fields[i];
            key = key.substring(1);
            key = key.replace('.data', '.options');
            getStaff().then(response => {
                _.set(raw, key, response)
                this.setState({'data': raw})
            })
        }
    }

    parseLoadedData(response, the_step, the_id) {
        let raw = response.data; // response.data for local, response.data.data for global

        // director address copy 
        for(let i=1; i<=5; i++) {
            try {
                if(typeof raw.elements.something.elements['director_' + i].elements.director_heading_wrap.elements.director_address_copy !== 'undefined') {
                    raw.elements.something.elements['director_' + i].elements.director_heading_wrap.elements.director_address_copy.onClick = (data,) => {
                        this.copyAddressData(data, i);
                    }
                }
            } catch(error) {
                // console.log('not found');
            }
        }

        // register back button
        if(the_step === 4 && typeof raw.elements.something !== 'undefined' && typeof raw.elements.something.elements.special !== 'undefined') {
            
            raw.elements.something.elements.special.onClick = () => {this.goToUrl('/case/CA000047') };
        }

        // register btn-link-1 button
        if(the_step !==2 && typeof raw.elements.something !== 'undefined' && typeof raw.elements.something.elements.back !== 'undefined') {
            raw.elements.something.elements.back.onClick = () => {this.goBack() };
        }

        // register multi-append buttons
        if(typeof raw.elements.add_additional_director!=='undefined') {
            raw.elements.add_additional_director.onClick = () => {
                this.duplicateAndAppendField('elements.director_multi_element.elements.director_details_1', 'elements.director_multi_element')
            };
        }
        if(typeof raw.elements.remove_additional_director!=='undefined') {
            raw.elements.remove_additional_director.onClick = () => {this.removeDuplicatedField('elements.director_multi_element')};
        }

        // add_security
        if(typeof raw.elements.add_additional_security!=='undefined') {
            raw.elements.add_additional_security.onClick = (e) => {
                
                let i = e.values;
                // let i = this.state.initial;
                i.attributes.security_selector = String(this.state.security_count + 1);
                let c = (this.state.security_count + 1);


                let newSchema = this.addSecurityOption(null, {}, c, "New Security Entry #" + (this.state.data.elements.security_selector.options.length), i);
                if(newSchema) {
                    newSchema[1].attributes.security_selector = String(this.state.data.elements.security_selector.options.length-1);
                    c = (newSchema[1].attributes.security_selector)
                    e.setFieldValue('attributes', newSchema[1].attributes);
                this.setState({security_count: c}, function(){
                    $('.security_element').addClass('d-none');
                    $('.security_element__' + c).removeClass('d-none');
                    // console.log('new schema initiated post addsecurity')
                });
            }
        };
        }

        // remove security
        if(typeof raw.elements.remove_additional_security!=='undefined') {
            raw.elements.remove_additional_security.onClick = (e) => {
                let to_remove = this.removeSecurityOption();
                e.setFieldValue("attributes.ForceDelete__" + to_remove, true);
                e.setFieldValue("attributes.security_selector", "0");
            };
        }          
        
        // add multicontact
        if(typeof raw.elements.add_additional_multicontact!=='undefined') {
            raw.elements.add_additional_multicontact.onClick = (e) => {
                
                let i = e.values;
                // let i = this.state.initial;
                i.attributes.multicontact_selector = String(this.state.multicontact_count + 1);
                let c = (this.state.multicontact_count + 1);

                let newSchema = this.addMulticontactOption(null, {}, c, "New Entry");
                
                e.setFieldValue("attributes.multicontact_selector", String(this.state.data.elements.multicontact_selector.options.length-1));

                this.setState({initial: i, data: newSchema, multicontact_count: c}, function(){
                    $('.multicontact_element').addClass('d-none');
                    $('.multicontact_element__' + c).removeClass('d-none');
                });
            };
        }

        // remove multicontact
        if(typeof raw.elements.remove_additional_multicontact!=='undefined') {
            raw.elements.remove_additional_multicontact.onClick = (e) => {
                let to_remove = this.removeMulticontactOption();
                e.setFieldValue("attributes.mc1_ForceDelete__" + to_remove, true);
                e.setFieldValue("attributes.multicontact_selector", "0");
            };
        }
        
        this.initializeCustomFieldTypes(raw);

        // @todo: shouldn't be checking for a step once we get field IDs
        if(the_step === 1 && typeof raw.elements.something !== 'undefined' && typeof raw.elements.something.elements.name !== 'undefined') {
            raw.elements.something.elements.name.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.something.elements.name.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.something.elements.name.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.something.elements.name.options.getSuggestionValue = getSuggestionValue;
            raw.elements.something.elements.name.options.renderSuggestion = renderSuggestion;
        }

        if(the_id == 29 && typeof raw.elements.company_fieldset !== 'undefined' && typeof raw.elements.company_fieldset.elements.Source !== 'undefined') {
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.Source.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.Source.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.CompanyName.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.CompanyName.options.renderSuggestion = renderSuggestion;
        }

        if(the_id == 14 && typeof raw.elements.company_fieldset !== 'undefined' && typeof raw.elements.company_fieldset.elements.CompanyName !== 'undefined') {
            raw.elements.intro_fieldset.elements.Source.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.intro_fieldset.elements.Source.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.intro_fieldset.elements.Source.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.intro_fieldset.elements.Source.options.getSuggestionValue = getSuggestionValue;
            raw.elements.intro_fieldset.elements.Source.options.renderSuggestion = renderSuggestion;

            raw.elements.intro_fieldset.elements.SourceAffiliate.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.intro_fieldset.elements.SourceAffiliate.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.intro_fieldset.elements.SourceAffiliate.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.intro_fieldset.elements.SourceAffiliate.options.getSuggestionValue = getSuggestionValue;
            raw.elements.intro_fieldset.elements.SourceAffiliate.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.CompanyName.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.CompanyName.options.renderSuggestion = renderSuggestion;
        }

        if(the_id == 36 && typeof raw.elements.company_fieldset !== 'undefined' && typeof raw.elements.company_fieldset.elements.Source !== 'undefined') {
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.Source.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.Source.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.CompanyName.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.CompanyName.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.CompanyName.options.renderSuggestion = renderSuggestion;
        }

        // if(the_id == 36 && typeof raw.elements.company_fieldset !== 'undefined' && typeof raw.elements.company_fieldset.elements.Source !== 'undefined') {
        //     raw.elements.company_fieldset.elements.Source.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
        //     raw.elements.company_fieldset.elements.Source.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
        //     raw.elements.company_fieldset.elements.Source.options.onSuggestionSelected = this.onSuggestionSelected;
        //     raw.elements.company_fieldset.elements.Source.options.getSuggestionValue = getSuggestionValue;
        //     raw.elements.company_fieldset.elements.Source.options.renderSuggestion = renderSuggestion;

        //     raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
        //     raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
        //     raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionSelected = this.onSuggestionSelected;
        //     raw.elements.company_fieldset.elements.SourceAffiliate.options.getSuggestionValue = getSuggestionValue;
        //     raw.elements.company_fieldset.elements.SourceAffiliate.options.renderSuggestion = renderSuggestion;
        // }

        if(the_id == 10 && typeof raw.elements.company_fieldset !== 'undefined' && typeof raw.elements.company_fieldset.elements.Source !== 'undefined') {
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.Source.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.Source.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.renderSuggestion = renderSuggestion;
        }

        if(the_id == 21 && typeof raw.elements.company_fieldset !== 'undefined' && typeof raw.elements.company_fieldset.elements.Source !== 'undefined') {
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.Source.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.Source.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.Source.options.renderSuggestion = renderSuggestion;

            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionsClearRequested = onSuggestionsClearRequested;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.onSuggestionSelected = this.onSuggestionSelected;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.getSuggestionValue = getSuggestionValue;
            raw.elements.company_fieldset.elements.SourceAffiliate.options.renderSuggestion = renderSuggestion;
        }

        

        if (the_step==3) {

            // payment_profile1 + payment_profile2; first_payment; 
            let initial = this.state.initial;
            console.log( initial.attributes );

            // localStorage.setItem('payment_profile1', pp1 );
            // localStorage.setItem('payment_profile2', pp2 );
            // localStorage.setItem('frequency', frequency );
            // localStorage.setItem('freq_multiplier', frequency );

            let pp1 = localStorage.getItem('payment_profile1');
            let pp2 = localStorage.getItem('payment_profile2');
            let start_date = localStorage.getItem('start_date');

            let individual_payments = parseInt(pp1) + parseInt(pp2) ;
            let monthly = localStorage.getItem('monthly');
            let payment_interval = moment(start_date, 'DD-MM-YYYY'); // 14-05-2021
            let freq = localStorage.getItem('freq_multiplier');

            // testing area
            // individual_payments = 3;
            //monthly = 5001;
            // freq = 'Yearly';

            let first_payment_diff_ceil = null;
            if(freq=='Monthly')     first_payment_diff_ceil = Math.ceil(payment_interval.diff(moment(), 'months', true));

            if(freq=='Half Year')     first_payment_diff_ceil = Math.round(payment_interval.diff(moment(), 'months', true)/6);
            if(freq=='Quarterly')     first_payment_diff_ceil = Math.round(payment_interval.diff(moment(), 'months', true)/3);
            if(freq=='Yearly')     first_payment_diff_ceil = Math.round(payment_interval.diff(moment(), 'months', true)/12);


            let today = moment();

            if(individual_payments>100) individual_payments = 100;

            for(let i=0; i<first_payment_diff_ceil; i++) {
                initial.attributes['skip_payment_" + i'] = 0;
                let lab1 = 'skip_payment_label_' + i;
                let lab2 = 'skip_payment_' + i;
                raw.elements.matchings.elements[lab1] = { "name": "attributes." + lab1, "label": freq + " " + (i+1) +" Payment (SKIP) (£) (" + today.format('DD-MM-YYYY') + ")", "type": "field", "attributes": { "placeholder": 0, "readonly": "readonly", "disabled": "disabled" }, "renderer": "text", "fieldType": "text" };
                raw.elements.matchings.elements[lab2] = { "name": "attributes." + lab2, "label": "-", "type": "field", "attributes": { "placeholder": "", "readonly": "readonly", "disabled": "disabled" }, "renderer": "text", "fieldType": "text" };   
                if(freq=='Monthly') today.add(1, 'M');
                if(freq=='Half Year') today.add(6, 'M');
                if(freq=='Quarterly') today.add(3, 'M');
                if(freq=='Yearly') today.add(1, 'Y');
            }
            this.setState({initial: initial});

            for(let i=0; i<individual_payments; i++) {
                let lab1 = 'payments' + i;
                let lab2 = 'fixed' + i;
                raw.elements.matchings.elements[lab1] = { "name": "attributes." + lab1, "label": freq + " " + (i+1) +" Payment (£) (" + payment_interval.format('DD-MM-YYYY') + ")", "type": "field", "attributes": { "placeholder": this.currency(monthly) }, "renderer": "text", "fieldType": "text" };
                raw.elements.matchings.elements[lab2] = { "name": "attributes." + lab2, "label": "Select", "type": "field", "renderer": "react-select",  "options": {"regular": "Regular", "every": "Every", "fixed": "Fixed"},  "fieldType": "text"  };   
                if(freq=='Monthly') payment_interval.add(1, 'M');
                if(freq=='Half Year') payment_interval.add(6, 'M');
                if(freq=='Quarterly') payment_interval.add(3, 'M');
                if(freq=='Yearly') payment_interval.add(1, 'Y');
            }
        }
        return { the_id: the_id, step: raw.step, steps: raw.steps, endpoint: raw.endpoint, data: raw, loading: false, form_name: raw.label }

    }

    initializeCustomFieldTypes(raw=null)
    {
        if(raw==null) {
            raw = this.state.schema;
        }
        
        // CustomCurrency
        let all_currency_fields = this.scan(raw, 'currency');
        for(let i=0; i<all_currency_fields.length; i++) {
            let key = all_currency_fields[i];
            key = key.substring(1);
            _.set(raw, key, CustomCurrency)
        }

        // CustomCurrencyNoDecimals
        let all_currency_0_fields = this.scan(raw, 'currency_0');
        for(let i=0; i<all_currency_0_fields.length; i++) {
            let key = all_currency_0_fields[i];
            key = key.substring(1);
            _.set(raw, key, CustomCurrencyNoDecimals)
        }

        let all_date_fields = this.scan(raw, 'date');
        for(let i=0; i<all_date_fields.length; i++) {
            let key = all_date_fields[i];
            key = key.substring(1);
            _.set(raw, key, CustomDate)
        }

        let all_sortcode_fields = this.scan(raw, 'sortcode');
        for(let i=0; i<all_sortcode_fields.length; i++) {
            let key = all_sortcode_fields[i];
            key = key.substring(1);
            _.set(raw, key, CustomSortCode)
        }

    }

    loadCase()
    {
        let applicant_id = queryString.parse(this.props.location.search).applicant_id;
        if(this.state.endpoint=="UpdateCase" && applicant_id) {

            // get case details
            axios.post(config().base_url + 'GetCase', {
                "UserInfo": {
                    "Username": localStorage.getItem('bo_email'),
                    "Password": localStorage.getItem('bo_password')
                },
                "CaseReference": applicant_id
            })
            .then(response => {
                console.log("Customer reference set to " +  response.data.d.CaseApplicant.CustomerReference);
                this.setState({
                    customer_reference: response.data.d.CaseApplicant.CustomerReference, 
            })
            }).catch(error => {
                console.log(error);
            });
        
        }
    }

    getFakeCase()
    {
        return { "d": { "__type": "OrangeMail.BrightofficeAPI+CaseEnquiryResult", "EnquiryResult": { "__type": "OrangeMail.BrightofficeAPI+SuccessInfo", "SuccessCode": 0, "Message": null }, "CaseApplicant": { "__type": "OrangeMail.BrightofficeAPI+CaseApplicant", "ApplicantID": "CA001513", "CustomerReference": "C001395", "MainApplicant": { "Title": null, "Firstname": "Test New Business", "Surname": null, "DateOfBirth": "\/Date(-62135596800000)\/", "Telephone": null, "WorkTelephone": null, "Mobile": "07815817096", "EmailAddress": "sarah@maison-parfaite.com", "CurrentAddress": { "HouseName": null, "HouseNumber": null, "Address1": "1 Victoria Court", "Address2": "Bank Square", "Address3": "Morley", "Address4": "Leeds", "PostCode": "LS27 9SE" }, "PreviousAddresses": [ { "HouseName": null, "HouseNumber": null, "Address1": null, "Address2": null, "Address3": null, "Address4": null, "PostCode": null } ], "App2ID": 1027 }, "AdditionalApplicants": [ { "Title": null, "Firstname": null, "Surname": null, "DateOfBirth": "\/Date(-62135596800000)\/", "Telephone": null, "WorkTelephone": null, "Mobile": null, "EmailAddress": null, "CurrentAddress": { "HouseName": null, "HouseNumber": null, "Address1": null, "Address2": null, "Address3": null, "Address4": null, "PostCode": null }, "PreviousAddresses": [], "App2ID": 1028 } ], "MatterType": "Business-Finance", "Provider": "Reward-Finance-Group-Ltd", "ProviderDescription": null, "ProviderRef": null, "ProviderCaseRef": null, "OldCaseRef": null, "CreditType": "Loan (S)", "NetClaim": 150000, "Term": 12, "InterestMonthly": 1.35, "Commission": 0, "ClaimInterest": 0, "CustomerInitialFee": 6000, "CustomerCompletionFeePerc": 0, "CustomerCompletionFee": 2000, "CaseStatus": "Prospect", "StatusDate": "\/Date(1616596195000)\/", "Source": null, "SourceRef": null, "SourceAffiliate": null, "DateCreated": "\/Date(1616544000000)\/", "UserCreated": 35024, "WorkflowStep": "1", "DaysOld": 1, "CaseOwner": "Tom Newhouse", "CustomerOwner": "Tom Newhouse", "CaseUnderWriter": "Parisa Lian", "CaseTeam": null, "CaseProcessor": "Alan Sanderson", "CaseAdditionalUser1": "Tom Newhouse", "CaseAdditionalUser2": null, "BrokerCode": null, "BrokerName": null, "BrokerReference": "", "CaseNotesList": [], "SecurityAddress": [ { "Code": "2822", "HouseName": null, "HouseNumber": "124", "Address1": "Micklegate", "Address2": "York", "Address3": null, "Address4": null, "Postcode": "YO1 6JX", "CurrentValue": 950000, "SecuirtyType": "Property", "SecuirtyDetails": "Holiday Let", "SecuirtyCharge": "2nd Charge", "SecuirtyChargeValue": 600000, "SecuirtyChargeDate": null, "SecuirtyEquityValue": 350000, "SecuirtyLendingValue": 160000, "SecuirtyPurchaseValue": 0, "SecuirtyPurchaseDate": null, "SecuirtyMortgageValue": 0, "SecuirtyMarketValue": 80, "SecurityTitleNumber": "NYK293682", "SecurityCustomField": [], "ForceDelete": null }, { "Code": "2823", "HouseName": "Maison Parfaite Investments", "HouseNumber": null, "Address1": null, "Address2": null, "Address3": null, "Address4": null, "Postcode": null, "CurrentValue": null, "SecuirtyType": "Debenture", "SecuirtyDetails": "Debenture", "SecuirtyCharge": "1st Charge", "SecuirtyChargeValue": null, "SecuirtyChargeDate": null, "SecuirtyEquityValue": 0, "SecuirtyLendingValue": 0, "SecuirtyPurchaseValue": 0, "SecuirtyPurchaseDate": null, "SecuirtyMortgageValue": 0, "SecuirtyMarketValue": 0, "SecurityTitleNumber": null, "SecurityCustomField": [], "ForceDelete": null }, { "Code": "2824", "HouseName": "Sarah McDermott", "HouseNumber": null, "Address1": null, "Address2": null, "Address3": null, "Address4": null, "Postcode": null, "CurrentValue": null, "SecuirtyType": "Personal Guarantee", "SecuirtyDetails": "Personal Guarantee", "SecuirtyCharge": null, "SecuirtyChargeValue": null, "SecuirtyChargeDate": null, "SecuirtyEquityValue": 0, "SecuirtyLendingValue": 0, "SecuirtyPurchaseValue": 0, "SecuirtyPurchaseDate": null, "SecuirtyMortgageValue": 0, "SecuirtyMarketValue": 0, "SecurityTitleNumber": null, "SecurityCustomField": [], "ForceDelete": null }, { "Code": "2825", "HouseName": "Sean McDermott", "HouseNumber": null, "Address1": null, "Address2": null, "Address3": null, "Address4": null, "Postcode": null, "CurrentValue": null, "SecuirtyType": "Personal Guarantee", "SecuirtyDetails": "Personal Guarantee", "SecuirtyCharge": null, "SecuirtyChargeValue": null, "SecuirtyChargeDate": null, "SecuirtyEquityValue": 0, "SecuirtyLendingValue": 0, "SecuirtyPurchaseValue": 0, "SecuirtyPurchaseDate": null, "SecuirtyMortgageValue": 0, "SecuirtyMarketValue": 0, "SecurityTitleNumber": null, "SecurityCustomField": [], "ForceDelete": null }, { "Code": "2826", "HouseName": "Aysgarth Nook", "HouseNumber": null, "Address1": "Aysgarth", "Address2": null, "Address3": "Leyburn", "Address4": "North Yorkshire", "Postcode": "DL8 3AH", "CurrentValue": null, "SecuirtyType": "Property", "SecuirtyDetails": "Holiday Let", "SecuirtyCharge": null, "SecuirtyChargeValue": null, "SecuirtyChargeDate": null, "SecuirtyEquityValue": null, "SecuirtyLendingValue": null, "SecuirtyPurchaseValue": null, "SecuirtyPurchaseDate": null, "SecuirtyMortgageValue": null, "SecuirtyMarketValue": null, "SecurityTitleNumber": null, "SecurityCustomField": [], "ForceDelete": null } /* */ ], "DynamicFieldDetail": [ { "FieldNo": "1", "FieldValue": "" }, { "FieldNo": "2", "FieldValue": "Working Capital" }, { "FieldNo": "3", "FieldValue": "5" }, { "FieldNo": "4", "FieldValue": "Accommodation & Food" }, { "FieldNo": "5", "FieldValue": "Direct Debit" }, { "FieldNo": "6", "FieldValue": "" }, { "FieldNo": "7", "FieldValue": "" }, { "FieldNo": "8", "FieldValue": "" }, { "FieldNo": "9", "FieldValue": "" }, { "FieldNo": "10", "FieldValue": "" }, { "FieldNo": "11", "FieldValue": "" }, { "FieldNo": "12", "FieldValue": "Nurture" }, { "FieldNo": "13", "FieldValue": "" } ], "IsUpdateCaseCustomer": null, "TotalCredit": 0, "TotalDebit": 0, "TotalBalance": 0, "CompanyAddress": { "HouseName": null, "HouseNumber": null, "Address1": "1 Victoria Court", "Address2": "Bank Square", "Address3": "Morley", "Address4": "Leeds", "Postcode": "LS27 9SE", "TimeInYears": null, "TimeInMonths": null }, "MultiContacts": [ { "Firstname": "Sarah", "Surname": "McDermott (guarantor)", "DirectPhone": null, "Email": "sarah@maison-parfaite.com", "Position": "Director", "Mobile": "07815817096", "Address1": "7 Goldcrest Road", "Address2": "Allerton Bywater", "Address3": "Castleford", "Address4": null, "PostCode": "WF10 2GF", "Guarantor": true, "DateOfBirth": "\/Date(243730800000)\/", "IncludeInPIP": true, "CustomFields": [ { "CustomFieldNo": "1", "CustomFieldValue": "50" }, { "CustomFieldNo": "2", "CustomFieldValue": "5+" } ] }, { "Firstname": "Sean", "Surname": "McDermott (not guarantor)", "DirectPhone": null, "Email": null, "Position": "Director", "Mobile": null, "Address1": "7 Goldcrest Road", "Address2": "Allerton Bywater", "Address3": "Castelford", "Address4": null, "PostCode": "WF10 2GF", "Guarantor": false, "DateOfBirth": "\/Date(-183945600000)\/", "IncludeInPIP": false, "CustomFields": [ { "CustomFieldNo": "1", "CustomFieldValue": "50" }, { "CustomFieldNo": "2", "CustomFieldValue": "5+" } ] } ], "SourceInitialFeePerc": 0, "SourceInitialFee": 0, "AffiliateInitialFeePerc": 0, "AffiliateInitialFee": 0, "AvoidUpdatingBlankData": null } } };
    }


    loadSecurity(schema, the_step, the_id)
    {

        let initial = this.state.initial;
        let that = this;
        // let source = "";

        if((the_id==7 || the_id==10 ||the_id==21 || the_id==18 || the_id==19 || the_id==13 || the_id==14 || the_id==15 || the_id==22 || the_id==29 || the_id==30 || the_id==31 || the_id==36 || the_id==37 || the_id==38 || the_id==39 || the_id==40 || the_id==42 || the_id==43 || the_id==50 || the_id==51) 
        && (queryString.parse(this.props.location.search).customer_reference || queryString.parse(this.props.location.search).applicant_id)) {

            let case_response = null;
            let customers_response = null;

            axios.post(config().base_url + 'GetCase', {
                "UserInfo": {
                    "Username": localStorage.getItem('bo_email'),
                    "Password": localStorage.getItem('bo_password')
                },
                "CaseReference": queryString.parse(this.props.location.search).applicant_id
            })
            .then(response => {
                
                case_response = response.data.d;

                if(localStorage.getItem('bo_email') == 'srdjanstojkovic.api') {
                    case_response = this.getFakeCase().d;
                }

                let search_customers_param = queryString.parse(this.props.location.search).customer_reference;
                if(the_id==31) {
                    search_customers_param = queryString.parse(this.props.location.search).applicant_id;
                }

                axios({
                    method: "post",
                    url: config().base_url + 'SearchCustomers',
                    data: {
                    "SearchParam": search_customers_param,
                    "UserInfo": {
                        "Username": localStorage.getItem('bo_email'),
                        "Password": localStorage.getItem('bo_password')}
                    }
                    }).then(response => {

                        if(response && response.data && response.data.d) {                        
                            customers_response = response.data.d;
                        }

                        // multicontacts 
                        if(case_response.CaseApplicant && case_response.CaseApplicant.MultiContacts && (the_id==14 || the_id==7 || the_id==18 || the_id==19 || the_id==37 || the_id==38 || the_id==42 || the_id==43)) {
                            for(let i=0; i<case_response.CaseApplicant.MultiContacts.length; i++) {
                                this.addMultiOption(schema, case_response.CaseApplicant.MultiContacts[i], i);
                                // if(i>0) {
                                //    this.duplicateAndAppendField('elements.director_multi_element.elements.director_details_1', 'elements.director_multi_element');
                                // }
                            }
                        }

                        // fill in dynamicData
                        if(case_response.CaseApplicant && case_response.CaseApplicant.DynamicFieldDetail) {
                            for(let i=0; i<case_response.CaseApplicant.DynamicFieldDetail.length; i++) {
                                
                                let key = "dynamicData" + case_response.CaseApplicant.DynamicFieldDetail[i]['FieldNo']; // dynamicData5, dynamicData6 etc
                                initial.attributes[key] = case_response.CaseApplicant.DynamicFieldDetail[i]['FieldValue'];

                                // console.log("Dynamic data key " + key + " set to " + case_response.CaseApplicant.DynamicFieldDetail[i]['FieldValue']);
                            }
                        }

                        
                        if(customers_response && typeof customers_response.Records[0] != 'undefined') {
                        initial.attributes.Company = customers_response.Records[0].CompanyName;
                        initial.attributes.B2B = customers_response.Records[0].B2BCustomer + "";
                        this.b2bChangeUpdateAction(initial.attributes.B2B);
                        initial.attributes.CompanyName = customers_response.Records[0].CompanyName;
                        initial.attributes.AltSalutation = customers_response.Records[0].AlternateSalutation;
                        initial.attributes.AlternativeSalutation = customers_response.Records[0].AlternateSalutation;
                        initial.attributes.Firstname = customers_response.Records[0].Firstname;
                        initial.attributes.firstName = customers_response.Records[0].Firstname;
                        initial.attributes.Surname = customers_response.Records[0].Surname;
                        initial.attributes.surname = customers_response.Records[0].Surname;
                        initial.attributes.compEmail = customers_response.Records[0].Email;

                        initial.attributes.SourceAffiliate = customers_response.Records[0].SourceAffiliateName;
                        initial.attributes.Source = customers_response.Records[0].SourceName;
                        initial.attributes.OwnerName = customers_response.Records[0].OwnerName;

                        initial.attributes.CustomFieldValue23 = searchCustomFieldsForIndex(customers_response.Records[0].CustomFields, 23);
                        initial.attributes.CustomFieldValue24 = searchCustomFieldsForIndex(customers_response.Records[0].CustomFields, 24);
                        initial.attributes.CaseAssignmentBranch = searchCustomFieldsForIndex(customers_response.Records[0].CustomFields, 25);


                        // initial.attributes.compAddress1 = customers_response.Records[0].CustomerAddress.Address1;
                        // initial.attributes.compAddress2 = customers_response.Records[0].CustomerAddress.Address2;
                        // initial.attributes.compAddress3 = customers_response.Records[0].CustomerAddress.Address3;
                        // initial.attributes.compAddress4 = customers_response.Records[0].CustomerAddress.Address4;
                        // initial.attributes.compPostcode = customers_response.Records[0].CustomerAddress.PostCode;
                        initial.attributes.compTelephone = customers_response.Records[0].Telephone;
                        initial.attributes.compMobile = customers_response.Records[0].Mobile;
                    }
                        if(typeof schema.elements.team_details != 'undefined' && case_response.CaseApplicant) {
                            initial.attributes.UnderWriter   = this.scanObjectArray(schema.elements.team_details.elements.UnderWriter.options, 'label', case_response.CaseApplicant.CaseUnderWriter, 'value')  ;
                            initial.attributes.Processor   = this.scanObjectArray(schema.elements.team_details.elements.Processor.options, 'label', case_response.CaseApplicant.CaseProcessor, 'value')  ;
                            initial.attributes.AdditionalUser1   = this.scanObjectArray(schema.elements.team_details.elements.AdditionalUser1.options, 'label', case_response.CaseApplicant.CaseAdditionalUser1, 'value')  ;    
                            initial.attributes.CaseAssignmentBranch   = this.scanObjectArray(schema.elements.team_details.elements.CaseAssignmentBranch.options, 'label', case_response.CaseApplicant.CaseAssignmentBranch, 'value')  ; 
                        }


                        this.setState({data: schema, security_count: this.state.security_count++, initial: initial }, () => {
                            let initial = this.state.initial;
                            // try to load introducer type 
                            axios.post(config().base_url + 'GetSource', { 
                                "UserInfo": { "Username": localStorage.getItem('bo_email'), "Password": localStorage.getItem('bo_password') }, 
                                "pRequest": { "Status": "", "SortType": "Desc", "SortBy": "Ref", "SearchType": "source", 
                                "SearchText": initial.attributes.Source, "RecordStartNo": "1", "RecordEndNo": "10000" } }) 
                            .then(response => { 
                                if(typeof response.data.d.Records[0].SourceTypes[0] != 'undefined') { 

                                    initial.attributes.SourceType = response.data.d.Records[0].SourceTypes[0].SourceType;

                                    initial.attributes.SourceAffEmail = (typeof (response.data.d.Records[0]['SourceAffiliates']) !== 'undefined') ? response.data.d.Records[0]['SourceAffiliates'][0]['Email'] : ''
                                    initial.attributes.SourcePrimaryContact = response.data.d.Records[0].Additional1UserName
            
                                    this.setState({ initial: initial });
                                }  }) .catch(error => { return null; });
                        });

                });

            });



        }
       
        if((the_id==10 || the_id==14 || the_id==9 || the_id==7 || the_id==18 || the_id==19 || the_id==20 || the_id==21 || the_id==22 || the_id==13 || the_id==15 || the_id==27 || the_id==28 || the_id==29 || the_id==34 || the_id==36 || the_id==37 || the_id==38 || the_id==39 || the_id==40 || the_id==42 || the_id==43 || the_id==44 || the_id==45 || the_id==46  || the_id==47 || the_id==48  || the_id==49 || the_id==50 || the_id==51  ) && queryString.parse(this.props.location.search).applicant_id) {

        let case_response = null;
        let case_assessor_response = null;

        // get case details
        axios.post(config().base_url + 'GetCase', {
            "UserInfo": {
                "Username": localStorage.getItem('bo_email'),
                "Password": localStorage.getItem('bo_password')
            },
            "CaseReference": queryString.parse(this.props.location.search).applicant_id
        })
        .then(response => {

            case_response = this.parseCaseResponse(response.data.d, the_id)

            if(localStorage.getItem('bo_email') == 'srdjan.stojkovicapi') {
                console.log('loading fake data');
                case_response = this.getFakeCase().d;
            }  

            // source = case_response.CaseApplicant.Source;

            axios.post(config().base_url + 'GetCaseAssessorByCaseJSON', {
                "UserInfo": {
                    "Username": localStorage.getItem('bo_email'),
                    "Password": localStorage.getItem('bo_password')
                },
                "jobCode": queryString.parse(this.props.location.search).applicant_id
            })
            .then(response => {


                case_assessor_response = response.data.d;

                /* Address1: null, Address2: null, Address3: null, Address4: null, Code: "4455", CurrentValue: 0, HouseName: null, HouseNumber: null
                Postcode: null, SecuirtyCharge: null, SecuirtyChargeDate: null, SecuirtyChargeValue: 0, SecuirtyDetails: null, SecuirtyEquityValue: 0
                SecuirtyLendingValue: 0, SecuirtyMarketValue: null, SecuirtyMortgageValue: 0, SecuirtyPurchaseDate: null, SecuirtyPurchaseValue: 0, 
                SecuirtyType: null, SecurityCustomField: [], SecurityTitleNumber: null */

                // let initial = this.state.initial;

                // securities
                if(typeof schema.elements.security_selector != 'undefined') {
                    schema.elements.security_selector.options = [];
                    if(typeof schema.elements.security_selector!='undefined' && case_response.CaseApplicant) {
                        for(let i=0; i<case_response.CaseApplicant.SecurityAddress.length; i++) {
                            this.addSecurityOption(schema, case_response.CaseApplicant.SecurityAddress[i], i);
                        }
                        if(case_response.CaseApplicant.SecurityAddress.length==0) {
                            this.addSecurityOption(schema, {}, 0, "New Security Entry #0");
                        }
                    }
                }

                // multicontacts 
                if(typeof schema.elements.multicontact_selector != 'undefined') {
                    schema.elements.multicontact_selector.options = [];
                    if(typeof schema.elements.multicontact_selector!='undefined' && case_response.CaseApplicant) {

                        for(let i=0; i<case_response.CaseApplicant.MultiContacts.length; i++) {
                            if(the_id != 14 || (the_id==14 && case_response.CaseApplicant.MultiContacts[i].Guarantor===true)) {
                                this.addMulticontactOption(schema, case_response.CaseApplicant.MultiContacts[i], i);
                            }
                        }

                        if(case_response.CaseApplicant.MultiContacts.length==0) {
                            this.addMulticontactOption(schema, {}, 0, "New Entry");
                        }

                    } else {
                        if(the_id==38 || the_id==37){
                            this.addMulticontactOption(schema, {}, 0, "New Entry");
                            // initial.attributes.mc1_MainApp__0 = "true";
                        }
                    }
                }

                // set other fields
                if(case_response.CaseApplicant) {
                    initial.attributes.Company = case_response.CaseApplicant.MainApplicant.Firstname;
                    initial.attributes.compAddress1 = case_response.CaseApplicant.CompanyAddress.Address1;
                    initial.attributes.compAddress2 = case_response.CaseApplicant.CompanyAddress.Address2;
                    initial.attributes.compAddress3 = case_response.CaseApplicant.CompanyAddress.Address3;
                    initial.attributes.compAddress4 = case_response.CaseApplicant.CompanyAddress.Address4;
                    initial.attributes.compPostcode = case_response.CaseApplicant.CompanyAddress.Postcode;
                    initial.attributes.FirstnameComp    = case_response.CaseApplicant.MainApplicant.Firstname;
                    initial.attributes.Firstname    = case_response.CaseApplicant.MainApplicant.Firstname;
                    initial.attributes.Surname      = case_response.CaseApplicant.MainApplicant.Surname;
                    initial.attributes.Telephone      = case_response.CaseApplicant.MainApplicant.Telephone;
                    initial.attributes.Mobile      = case_response.CaseApplicant.MainApplicant.Mobile;
                    initial.attributes.Email      = case_response.CaseApplicant.MainApplicant.EmailAddress;
                    initial.attributes.MainAppEmail      = case_response.CaseApplicant.MainApplicant.EmailAddress;
                    initial.attributes.Address1 = case_response.CaseApplicant.MainApplicant.CurrentAddress.Address1;
                    initial.attributes.Address2 = case_response.CaseApplicant.MainApplicant.CurrentAddress.Address2;
                    initial.attributes.Address3 = case_response.CaseApplicant.MainApplicant.CurrentAddress.Address3;
                    initial.attributes.Address4 = case_response.CaseApplicant.MainApplicant.CurrentAddress.Address4;
                    initial.attributes.Postcode = case_response.CaseApplicant.MainApplicant.CurrentAddress.Postcode;
                    initial.attributes.NetClaim     = case_response.CaseApplicant.NetClaim;
                    initial.attributes.CustomerInitialFee    = case_response.CaseApplicant.CustomerInitialFee;
                    initial.attributes.InterestMonthly       = case_response.CaseApplicant.InterestMonthly;
                    initial.attributes.CustomerCompletionFee = case_response.CaseApplicant.CustomerCompletionFee;
                    initial.attributes.Term         = case_response.CaseApplicant.Term;
                    initial.attributes.Source       = case_response.CaseApplicant.SourceName;
                    initial.attributes.SourceAffiliate       = case_response.CaseApplicant.SourceAffiliateName;
                    initial.attributes.SourceRef       = case_response.CaseApplicant.SourceRef;
                    initial.attributes.SourceInitialFee   = case_response.CaseApplicant.SourceInitialFee;
                    initial.attributes.SourceCommissionPerc   = case_response.CaseApplicant.SourceCommissionPerc;
                    initial.attributes.Commission   = case_response.CaseApplicant.Commission;
                    initial.attributes.SecurityCover   = case_response.CaseApplicant.SecurityCover;

                    initial.attributes.PaymentDate   = case_response.CaseApplicant.ApplicationProgressDates ? case_response.CaseApplicant.ApplicationProgressDates.PaymentDate : null;
                    initial.attributes.SoldDate   = case_response.CaseApplicant.ApplicationProgressDates ? case_response.CaseApplicant.ApplicationProgressDates.SoldDate : null;

                    initial.attributes.account_name = case_response.CaseApplicant.MainApplicant.BankDetail[0] ? case_response.CaseApplicant.MainApplicant.BankDetail[0].AccountName : "";
                    initial.attributes.account_number = case_response.CaseApplicant.MainApplicant.BankDetail[0] ? case_response.CaseApplicant.MainApplicant.BankDetail[0].AccountNumber : "";
                    initial.attributes.sort_code = case_response.CaseApplicant.MainApplicant.BankDetail[0] ? case_response.CaseApplicant.MainApplicant.BankDetail[0].SortCode : "";

                    if(typeof schema.elements.team_details != 'undefined') {
                        initial.attributes.UnderWriter   = this.scanObjectArray(schema.elements.team_details.elements.UnderWriter.options, 'label', case_response.CaseApplicant.CaseUnderWriter, 'value')  ;
                        initial.attributes.Processor   = this.scanObjectArray(schema.elements.team_details.elements.Processor.options, 'label', case_response.CaseApplicant.CaseProcessor, 'value')  ;
                        initial.attributes.AdditionalUser1   = this.scanObjectArray(schema.elements.team_details.elements.AdditionalUser1.options, 'label', case_response.CaseApplicant.CaseAdditionalUser1, 'value')  ;    
                    }                    
                }

                // fill in retrieved assessors 
                if(case_assessor_response.Records) {
                    for(let i=0; i<case_assessor_response.Records.length; i++) {
                        let key = "caseAssessor" + case_assessor_response.Records[i]['Qno']; // caseAssessor23, 24 etc
                        initial.attributes[key] = case_assessor_response.Records[i]['Answer'];
                    }
                }

                // fill in dynamicData
                if(case_response.CaseApplicant && case_response.CaseApplicant.DynamicFieldDetail) {
                    for(let i=0; i<case_response.CaseApplicant.DynamicFieldDetail.length; i++) {
                        
                        let key = "dynamicData" + case_response.CaseApplicant.DynamicFieldDetail[i]['FieldNo']; // dynamicData5, dynamicData6 etc
                        initial.attributes[key] = case_response.CaseApplicant.DynamicFieldDetail[i]['FieldValue'];

                    }
                }

                // lets set the first option active & show first security
                initial.attributes.security_selector = "0";
                this.setState({data: schema, security_count: this.state.security_count++, initial: initial });
                $('.security_element').addClass('d-none');
                $('.security_element__0').removeClass('d-none');


            });

        })
        .then(function() {
            // load source 
        })
        .catch(error => {
            console.log(error);
        });
        }
    }

    async getSource(input, initial) {
            // deprecated
    }

    parseCaseResponse(response, the_id) {
        if(the_id==42) {
            // RP-6 on form 42 it check the API response and if ANY securities have a status of ‘Review’ then ONLY show them 
            // 2023-03-14 or status is To Be Released
            // IF no securities have a status of Review then show 'Live'
            if(response.CaseApplicant && response.CaseApplicant.SecurityAddress) {

                let newSecurityArrayLive = []
                let newSecurityArrayReview = []

                // count items with status == 'review'
                let with_review_status = 0
                for(let i=0; i<response.CaseApplicant.SecurityAddress.length; i++) {
                    if(response.CaseApplicant.SecurityAddress[i].SecurityStatus==='Review' || response.CaseApplicant.SecurityAddress[i].SecurityStatus==='To Be Released' ) {
                        with_review_status ++;
                        newSecurityArrayReview.push(response.CaseApplicant.SecurityAddress[i])
                    }
                    if(response.CaseApplicant.SecurityAddress[i].SecurityStatus==='Live') {
                        newSecurityArrayLive.push(response.CaseApplicant.SecurityAddress[i])
                    }
                }

                
                let show_only_status = (with_review_status>0) ? "Review" : "Live"

                if(show_only_status==='Review') {
                    response.CaseApplicant.SecurityAddress = newSecurityArrayReview
                } else {
                    response.CaseApplicant.SecurityAddress = newSecurityArrayLive
                }


            }
        }
        console.log(response.CaseApplicant.SecurityAddress)

        return response
    }


    copyAddressData(data, i)
    {
        data.setFieldValue("attributes.director" + i + "_address1", data.values.attributes.ba1);
        data.setFieldValue("attributes.director" + i + "_address2", data.values.attributes.ba2);
        data.setFieldValue("attributes.director" + i + "_address3", data.values.attributes.city);
        data.setFieldValue("attributes.director" + i + "_address4", data.values.attributes.county);
        data.setFieldValue("attributes.director" + i + "_postcode", data.values.attributes.postcode);
    }

    addMultiOption(schema, entry, unique) {
        let form_id = this.state.the_id;
        let initial = this.state.initial;
        // let unique = this.state.multicontacts_autoincrement;
        if(unique) {
            this.setState({security_autoincrement: unique + 1});
        }

        if(!schema) {
            schema = this.state.data
        }

        let sufix = "";
        if(unique>0) sufix = "__" + unique;

        initial.attributes['mc1_Firstname' + sufix] = entry.Firstname;
        initial.attributes['mc1_Surname' + sufix] = entry.Surname;
        initial.attributes['mc1_address1' + sufix] = entry.Address1;
        initial.attributes['mc1_address2' + sufix] = entry.Address2;
        initial.attributes['mc1_address3' + sufix] = entry.Address3;
        initial.attributes['mc1_address4' + sufix] = entry.Address4;
        initial.attributes['mc1_postcode' + sufix] = entry.PostCode

        initial.attributes['mc1_position' + sufix] = entry.Position;
        initial.attributes['mc1_telephone' + sufix] = entry.DirectPhone;
        initial.attributes['mc1_mobile' + sufix] = entry.Mobile;
        initial.attributes['mc1_email' + sufix] = entry.Email;
        initial.attributes['mc1_DateOfBirth' + sufix] = convertDate(entry.DateOfBirth);

        initial.attributes['mc1_CustomFieldValue1' + sufix] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '1', 'CustomFieldValue'); // Shareholding %
        initial.attributes['mc1_CustomFieldValue2' + sufix] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '2', 'CustomFieldValue'); // Years at Address - Years
        initial.attributes['mc1_CustomFieldValue3' + sufix] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '3', 'CustomFieldValue'); // Months at Address
        initial.attributes['mc1_MainApp__' + sufix] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '5', 'CustomFieldValue'); // Main Applicant
        if(typeof entry.IncludeInPIP != 'undefined') {
            initial.attributes['mc1_IncludeInPIP' + sufix] = (entry.IncludeInPIP===true) ? 'true' : 'false'; // PIP
        }

        return schema;
    }

    scanObjectArray(arr, find_key_name, find_key_value, return_field) {
        if(!Array.isArray(arr)) return null;
        for(let i=0; i<arr.length; i++) {
            if(arr[i][find_key_name]==find_key_value) {
                return arr[i][return_field];
            }
        }
        return null;
    }

    addSecurityOption(schema, entry, i, label=null, initial = null) {

        let form_id = this.state.the_id;

        if(entry.SecurityStatus === "Archived") {
            alert("This item is Archived")
            return false;
        }

        if(form_id == 43 && entry.SecurityStatus !== 'Review' && entry.SecurityStatus !== 'To Be Released') {
            return false;
        }

        if(initial===null) {
            initial = this.state.initial;
        }
        i = this.state.data.elements.security_selector.options.length;
        this.setState({security_autoincrement: i });

        // populate security selector options
        if(label==null) label = (entry['SecuirtyType'] ?? "") + " " + (entry['HouseName'] ?? "") + " " + (entry['Address1'] ?? "");

        if(!schema) {
            schema = this.state.data
        }

        if(_.isEmpty(schema.elements.security_selector.options)) {
            schema.elements.security_selector.options= [];
        }
        schema.elements.security_selector.options.push({'value': String(i), 'label': label });

        // populate values (attributes)
        // Asset Type - this will be replaced with the drop down of SecuirtyDetails that you get returned
        // CurrentValue__0 = CurrentValue
        // Lending Multiplier = SecuirtyMarketValue
        // Prior Charges = SecuirtyChargeValue
        // Equity Val = SecuirtyEquityValue
        // Lending Val = SecuirtyLendingValue

        if(typeof entry.Code == 'undefined') {
            entry.Code = "";
        }

        initial.attributes['SecurityID__' + i] = i;
        initial.attributes['ForceDelete__' + i] = false;

        // Ollie Additional SecurityStatus
        initial.attributes['SecurityStatus__' + i] = entry.SecurityStatus ? entry.SecurityStatus : (form_id==42 ? "Review" : "Live");
        initial.attributes['SecurityType__' + i] = entry.SecuirtyType;
        initial.attributes['SecuritySubType__' + i] = entry.SecuritySubType;
        initial.attributes['SecurityCharge__' + i] = entry.SecuirtyCharge;
        initial.attributes['SecurityDetails__' + i] = entry.SecuirtyDetails;
        initial.attributes['SecurityHouseNo__' + i] = entry.HouseNumber;
        initial.attributes['SecurityHouseName__' + i] = entry.HouseName;
        initial.attributes['SecurityAddress1__' + i] = entry.Address1;
        initial.attributes['SecurityAddress2__' + i] = entry.Address2;
        initial.attributes['SecurityAddress3__' + i] = entry.Address3;
        initial.attributes['SecurityAddress4__' + i] = entry.Address4;
        initial.attributes['SecurityPostcode__' + i] = entry.Postcode;
        initial.attributes['SecurityTitle__' + i] = entry.SecurityTitleNumber;
        initial.attributes['SecuirtyAgreedCap__' + i] = entry.SecuirtyAgreedCap;
        initial.attributes['SecurityInsuranceExpiryDate__' + i] = entry.SecurityInsuranceExpiryDate;

        //Futher Additions for Enhanced Security on Custom Fields
        initial.attributes['SecuirtyGivenBy__' + i] = this.scanObjectArray(entry.SecurityCustomField, 'CustomFieldNo', '1', 'CustomFieldValue');
        initial.attributes['SecuirtyValuationType__' + i] = this.scanObjectArray(entry.SecurityCustomField, 'CustomFieldNo', '2', 'CustomFieldValue');
        initial.attributes['SecuirtyValuationDate__' + i] = this.scanObjectArray(entry.SecurityCustomField, 'CustomFieldNo', '3', 'CustomFieldValue');
        initial.attributes['SecuirtyValuer__' + i] = this.scanObjectArray(entry.SecurityCustomField, 'CustomFieldNo', '4', 'CustomFieldValue');
        // initial.attributes['SecurityInsuranceExpiryDate__' + i] = this.scanObjectArray(entry.SecurityCustomField, 'CustomFieldNo', '5', 'CustomFieldValue');

        // Original
        initial.attributes['CurrentValue__' + i] = entry.CurrentValue;
        initial.attributes['security_multiplier__' + i] = entry.SecuirtyMarketValue;
        initial.attributes['SecuirtyChargeValue__' + i] = entry.SecuirtyChargeValue;
        initial.attributes['SecuirtyEquityValue__' + i] = entry.SecuirtyEquityValue;
        initial.attributes['SecuirtyLendingValue__' + i] = entry.SecuirtyLendingValue;

        initial.attributes['SecuirtyCode__' + i] = entry.Code ? entry.Code : null

        // Custom fields
        // CustomFieldNo : "1" CustomFieldValue : "Hardcastle Investments Limited"
        if(typeof(entry.SecurityCustomField)=='undefined'){
            entry.SecurityCustomField = []
        }

        for(let j=0; j<entry.SecurityCustomField.length; j++) {
            let cfNo = entry.SecurityCustomField[j].CustomFieldNo
            let cfValue = entry.SecurityCustomField[j].CustomFieldValue
            initial.attributes['SecuirtyCustomField__' + i + '_' + cfNo] = cfValue;
        }

        // populate structure
        let additional_class = (i==0) ? "" : "d-none";
        schema.elements.security_multi_element.elements['security_details_' + i] = {
            htmlClass: "row0 repeat security_element security_element__" + i + " " + additional_class, renderer: "div", type: "container", elements: null
        };

        schema.elements.security_multi_element.elements['security_details_' + i].elements = { 
            // Ollie Additional

            "SecurityType": { "name": "attributes.SecurityType__" + i, "label": "Security Type", "type": "field", "renderer": "react-select", "options": [
                {"value": "Aircraft", "label": "Aircraft"}, 
                {"value": "Allocation", "label": "Allocation"}, 
                {"value": "Boat", "label": "Boat"}, 
                {"value": "Bond and Floating Charge", "label": "Bond and Floating Charge"},
                {"value": "Book Debts", "label": "Book Debts"}, 
                {"value": "Commodity", "label": "Commodity"}, 
                {"value": "Corporate Guarantee", "label": "Corporate Guarantee"}, 
                {"value": "Debenture", "label": "Debenture"}, 
                {"value": "Equipment", "label": "Equipment"}, 
                {"value": "Financial Asset", "label": "Financial Asset"}, 
                {"value": "Health & Education", "label": "Health & Education"}, 
                {"value": "Industrial", "label": "Industrial"}, 
                {"value": "Inventory", "label": "Inventory"}, 
                {"value": "Land", "label": "Land"},
                {"value": "Leisure", "label": "Leisure"}, 
                {"value": "Mixed Use", "label": "Mixed Use"}, 
                {"value": "Offices", "label": "Offices"}, 
                {"value": "Personal Guarantee", "label": "Personal Guarantee"}, 
                {"value": "Personal Guarantee Supported by", "label": "Personal Guarantee Supported by"},
                {"value": "Residential - let / rental", "label": "Residential - let / rental"}, 
                {"value": "Residential - owner occupied", "label": "Residential - owner occupied"},
                {"value": "Retail", "label": "Retail"}, 
                {"value": "Stocks", "label": "Stocks"}, 
                {"value": "Vehicle", "label": "Vehicle"}, 
        ], "fieldType": "text" },

            "SecuritySubType": { "name": "attributes.SecuritySubType__" + i, "label": "Security Sub Type", "type": "field", "renderer": "react-select", "options": this.getSecuritySubtypeOptions(entry.SecuirtyType), "fieldType": "text" },

            "SecurityCharge": { "name": "attributes.SecurityCharge__" + i, "label": "Security Charge", "type": "field", "renderer": "react-select", "options": [{"value": "1st Charge", "label": "1st Charge"}, {"value": "2nd Charge", "label": "2nd Charge"}, {"value": "3rd Charge", "label": "3rd Charge"}], "fieldType": "text" },
            // "SecurityDetails": { "name": "attributes.SecurityDetails__" + i, "label": "Security Details", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityHouseNo": { "name": "attributes.SecurityHouseNo__" + i, "label": "House No", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityHouseName": { "name": "attributes.SecurityHouseName__" + i, "label": "Name (House, Company, Guarantor etc)", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityAddress1": { "name": "attributes.SecurityAddress1__" + i, "label": "Address 1", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityAddress2": { "name": "attributes.SecurityAddress2__" + i, "label": "Address 2", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityAddress3": { "name": "attributes.SecurityAddress3__" + i, "label": "Address 3", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityAddress4": { "name": "attributes.SecurityAddress4__" + i, "label": "Address 4", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityPostcode": { "name": "attributes.SecurityPostcode__" + i, "label": "Postcode", "type": "field", "renderer": "text", "fieldType": "text" },
            "SecurityTitle": { "name": "attributes.SecurityTitle__" + i, "label": "Title Number", "type": "field", "renderer": "text", "fieldType": "text" },
        };

        if(form_id==14 || form_id==18) {
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecurityStatus = { "name": "attributes.SecurityStatus__" + i, "label": "Status", "type": "field", "renderer": "react-select", "options": [{ "label": "Live", "value": "Live" }, {"label": "Archived", "value": "Archived"}], "fieldType": "text" };
        }

        if(form_id==10 || form_id==21 || form_id==39 || form_id==40 || form_id==42 || form_id==43  || form_id==50  || form_id==51) {
            schema.elements.security_multi_element.elements['security_details_' + i].elements.CurrentValue = { "name": "attributes.CurrentValue__" + i, "label": "Value (£)", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.neededsecurity_multiplier = { "name": "attributes.security_multiplier__" + i, "label": "Lending Multiplier %", "type": "field", "renderer": "text", "fieldType": "text" }
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyChargeValue = { "name": "attributes.SecuirtyChargeValue__" + i, "label": "Prior Charges (£)", "type": "field", "renderer": "text", "fieldType": "text" };

            // New BRD Ones
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyAgreedCap = { "name": "attributes.SecuirtyAgreedCap__" + i, "label": "Agreed Cap on LV (£)", "type": "field", "renderer": "text", "fieldType": "text" };

            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuationType = { "name": "attributes.SecuirtyValuationType__" + i, "label": "Valuation Type", "type": "field", "renderer": "react-select", "options": [{ "label": "RICS/Red Book to Reward (L1)", "value": "RICS/Red Book to Reward (L1)" }, {"label": "RICS/Red Book to Financial Institution (L2)", "value": "RICS/Red Book to Financial Institution (L2)"}, {"label": "Desktop RICS - shortform (L3)", "value": "Desktop RICS - shortform (L3)"}, {"label": "Purchase Price within 6 months (L3)", "value": "Purchase Price within 6 months (L3)"}, {"label": "Desktop Reward (L4)", "value": "Desktop Reward (L4)"},], "fieldType": "text" };

            // schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuationType = { "name": "attributes.SecuirtyValuationType__" + i, "label": "Valuation Type", "type": "field", "renderer": "text", "fieldType": "text" };

            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyGivenBy = { "name": "attributes.SecuirtyGivenBy__" + i, "label": "Given By", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuationDate = { "name": "attributes.SecuirtyValuationDate__" + i, "label": "Valuation Date", "type": "field", "renderer": CustomDate, "fieldType": CustomDate };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecurityInsuranceExpiryDate = { "name": "attributes.SecurityInsuranceExpiryDate__" + i, "label": "Insurance Expiry Date", "type": "field", "renderer": CustomDate, "fieldType": CustomDate };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuer = { "name": "attributes.SecuirtyValuer__" + i, "label": "Valuer", "type": "field", "renderer": "text", "fieldType": "text" };

            if(form_id==42 || form_id==43) {
                schema.elements.security_multi_element.elements['security_details_' + i].elements.SecurityStatus = { "name": "attributes.SecurityStatus__" + i, "label": "Status", "type": "field", "renderer": "react-select", "options": [{ "label": "Live", "value": "Live" }, {"label": "Review", "value": "Review"}, {"label": "To Be Released", "value": "To Be Released"}], "fieldType": "text" };
            } else {
                schema.elements.security_multi_element.elements['security_details_' + i].elements.SecurityStatus = { "name": "attributes.SecurityStatus__" + i, "label": "Status", "type": "field", "renderer": "react-select", "options": [{ "label": "Live", "value": "Live" }, {"label": "Archived", "value": "Archived"}, {"label": "Review", "value": "Review"}], "fieldType": "text" };
            }


        }

        if(form_id==34) {

            schema.elements.security_multi_element.elements['security_details_' + i].elements = {};
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyGivenBy = { "name": "attributes.SecuirtyGivenBy__" + i, "label": "Given By", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuationDate = { "name": "attributes.SecuirtyValuationDate__" + i, "label": "Valuation Date", "type": "field", "renderer": CustomDate, "fieldType": CustomDate };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuationType = { "name": "attributes.SecuirtyValuationType__" + i, "label": "Valuation Type", "type": "field", "renderer": "react-select", "options": [{ "label": "RICS/Red Book to Client", "value": "RICS/Red Book to Client" }, {"label": "RICS/Red Book to Reward", "value": "RICS/Red Book to Reward"}, {"label": "RICS/Red Book to Third Party Lender", "value": "RICS/Red Book to Third Party Lender"}, {"label": "Desktop Reward", "value": "Desktop Reward"}, {"label": "Desktop Valuer", "value": "Desktop Valuer"}, {"label": "Independent Assessment not RICS/Red Book", "value": "Independent Assessment (not RICS/Red Book)"}, {"label": "Sales Particulars/Purchase Price", "value": "Sales Particulars/Purchase Price" }], "fieldType": "text" };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecurityInsuranceExpiryDate = { "name": "attributes.SecurityInsuranceExpiryDate__" + i, "label": "Insurance Expiry Date", "type": "field", "renderer": CustomDate, "fieldType": CustomDate };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuer = { "name": "attributes.SecuirtyValuer__" + i, "label": "Valuer", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.security_multi_element.elements['security_details_' + i].elements.SecurityStatus = { "name": "attributes.SecurityStatus__" + i, "label": "Status", "type": "field", "renderer": "react-select", "options": [{ "label": "Live", "value": "Live" }, {"label": "Archived", "value": "Archived"}], "fieldType": "text" };

            //schema.elements.security_multi_element.elements['security_details_' + i].elements.CurrentValue = { "name": "attributes.CurrentValue__" + i, "label": "Value (£)", "type": "field", "renderer": "text", "fieldType": "text" };
            //schema.elements.security_multi_element.elements['security_details_' + i].elements.neededsecurity_multiplier = { "name": "attributes.security_multiplier__" + i, "label": "Lending Multiplier %", "type": "field", "renderer": "text", "fieldType": "text" }
            //schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyChargeValue = { "name": "attributes.SecuirtyChargeValue__" + i, "label": "Prior Charges (£)", "type": "field", "renderer": "text", "fieldType": "text" };

            
            // schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyValuationType = { "name": "attributes.SecuirtyValuationType__" + i, "label": "Valuation Type", "type": "field", "renderer": "react-select", "options": [{ "RICS/Red Book to Client": "RICS/Red Book to Client" }, {"RICS/Red Book to Reward": "RICS/Red Book to Reward"}, {"RICS/Red Book to Third Party Lender": "RICS/Red Book to Third Party Lender"}, {"Desktop Reward": "Desktop Reward"}, {"Desktop Valuer": "Desktop Valuer"}, {"Independent Assessment not RICS/Red Book":  "Independent Assessment (not RICS/Red Book)"}, {"Sales Particulars/Purchase Price": "Sales Particulars/Purchase Price" }], "fieldType": "text" },
        }

        initial.attributes['SecurityStatus__' + i] = entry.SecurityStatus ? entry.SecurityStatus : (form_id==42 ? "Review" : "Live");


        console.log('returning data from add-security')
        console.log(initial)
        return [schema, initial];

    }

    addMulticontactOption(schema, entry, i, label=null) {

        let form_id = this.state.the_id;
        let initial = this.state.initial;
        
        if(!Array.isArray(this.state.data.elements.multicontact_selector.options)) {
            this.state.data.elements.multicontact_selector.options = [];
        }

        i = this.state.data.elements.multicontact_selector.options.length;
        this.setState({multicontact_autoincrement: i });

        // populate multicontact selector options
        if(label==null) label = (entry['Firstname'] ?? "") + " " + (entry['Surname'] ?? "");

        if(!schema) {
            schema = this.state.data
        }
       
        schema.elements.multicontact_selector.options.push({'value': String(i), 'label': label });

        // populate values (attributes)

        if(typeof entry.Code == 'undefined') {
            entry.Code = "";
        }

        initial.attributes['SecurityID__' + i] = i;
        initial.attributes['ForceDelete__' + i] = false;

        // 
        initial.attributes['mc1_Firstname__' + i] = entry.Firstname;
        initial.attributes['mc1_Surname__' + i] = entry.Surname;
        initial.attributes['mc1_address1__' + i] = entry.Address1;
        initial.attributes['mc1_address2__' + i] = entry.Address2;
        initial.attributes['mc1_address3__' + i] = entry.Address3;
        initial.attributes['mc1_address4__' + i] = entry.Address4;
        initial.attributes['mc1_postcode__' + i] = entry.PostCode;

        initial.attributes['mc1_telephone__' + i] = entry.DirectPhone;
        initial.attributes['mc1_mobile__' + i] = entry.Mobile;
        initial.attributes['mc1_email__' + i] = entry.Email;
        initial.attributes['mc1_position__' + i] = entry.Position;
        initial.attributes['mc1_DateOfBirth__' + i] = convertDate(entry.DateOfBirth);
        initial.attributes['mc1_CustomFieldValue1__' + i] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '1', 'CustomFieldValue');
        initial.attributes['mc1_CustomFieldValue2__' + i] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '2', 'CustomFieldValue');
        initial.attributes['mc1_CustomFieldValue3__' + i] = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '3', 'CustomFieldValue');

        let mapp = this.scanObjectArray(entry.CustomFields, 'CustomFieldNo', '5', 'CustomFieldValue');
        if(mapp===null && i===0) {
            initial.attributes['mc1_MainApp__' + i] = 'true';
        } else {
            if(mapp===null) {
                initial.attributes['mc1_MainApp__' + i] = 'false';
            } else {
                initial.attributes['mc1_MainApp__' + i] = mapp;
            }
        }
        initial.attributes['mc1_IncludeInPIP__' + i] = entry.IncludeInPIP;

        // populate structure
        let additional_class = (i==0) ? "" : "d-none";
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i] = {
            htmlClass: "row0 repeat multicontact_element multicontact_element__" + i + " " + additional_class, renderer: "div", type: "container", elements: null
        };


        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements = {};

        if(form_id==37|| form_id==38) {
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_MainApp = { "htmlClass": "form-group required", "name": "attributes.mc1_MainApp__" + i, "label": "Main Applicant", "type": "field",  "attributes": {"validation": "required"},"renderer": "react-select", "options": [{"value": "false","label": "No"}, { "value": "true","label": "Yes"},], "fieldType": "text"};
        }

        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_Firstname = { "name": "attributes.mc1_Firstname__" + i, "htmlClass": "form-group clearfix",   "label": "Firstname", "type": "field", "renderer": "text", "fieldType": "text" };
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_Surname   =  { "name": "attributes.mc1_Surname__" + i, "label": "Surname", "type": "field", "renderer": "text", "fieldType": "text" };
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_address1  =  { "name": "attributes.mc1_address1__" + i, "label": "Address 1", "type": "field", "renderer": "text", "fieldType": "text" };
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_address2  = { "name": "attributes.mc1_address2__" + i, "label": "Address 2", "type": "field", "renderer": "text", "fieldType": "text" };
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_address3  ={ "name": "attributes.mc1_address3__" + i, "label": "Address 3", "type": "field", "renderer": "text", "fieldType": "text" };
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_address4  =  { "name": "attributes.mc1_address4__" + i, "label": "Address 4", "type": "field", "renderer": "text", "fieldType": "text" };
        schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_postcode  ={ "name": "attributes.mc1_postcode__" + i, "label": "Postcode", "type": "field", "renderer": "text", "fieldType": "text" }


        if(form_id==7 || form_id==19 || form_id==37|| form_id==38) {
            //schema.elements.security_multi_element.elements['security_details_' + i].elements.CurrentValue = { "name": "attributes.CurrentValue__" + i, "label": "Value (£)", "type": "field", "renderer": "text", "fieldType": "text" };
            //schema.elements.security_multi_element.elements['security_details_' + i].elements.neededsecurity_multiplier = { "name": "attributes.security_multiplier__" + i, "label": "Lending Multiplier %", "type": "field", "renderer": "text", "fieldType": "text" }
            //schema.elements.security_multi_element.elements['security_details_' + i].elements.SecuirtyChargeValue = { "name": "attributes.SecuirtyChargeValue__" + i, "label": "Prior Charges (£)", "type": "field", "renderer": "text", "fieldType": "text" };
            //schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_Firstname = {"name": "attributes.mc1_Firstname__" + i, "label": "Firstname", "type": "field", "renderer": "text", "fieldType": "text"};
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_position = { "name": "attributes.mc1_position__" + i, "label": "Position", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_telephone = {"name": "attributes.mc1_telephone__" + i, "label": "Telephone", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_mobile = { "name": "attributes.mc1_mobile__" + i, "label": "Mobile", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_email = { "name": "attributes.mc1_email__" + i, "label": "Email", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_CustomFieldValue1 = { "name": "attributes.mc1_CustomFieldValue1__" + i, "label": "Shareholding %", "type": "field", "renderer": "text", "fieldType": "text" };
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_DateOfBirth = { "name": "attributes.mc1_DateOfBirth__" + i, "label": "Date of Birth", "type": "field", "renderer": CustomDate, "fieldType": CustomDate };
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_CustomFieldValue2 = { "name": "attributes.mc1_CustomFieldValue2__" + i, "label": "Years at Address - Years", "type": "field", "renderer": "react-select","options": {"1": "1", "2": "2", "3": "3", "4": "4", "5": "5+" }, "fieldType": "text"};
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_CustomFieldValue3 = { "name": "attributes.mc1_CustomFieldValue3__" + i, "label": "Months", "type": "field",  "renderer": "react-select", "options": { "1": "1", "2": "2", "3": "3", "4": "4", "5": "5", "6": "6", "7": "7", "8": "8", "9": "9", "10": "10", "11": "11" }, "fieldType": "text"};
            schema.elements.multicontact_multi_element.elements['multicontact_details_' + i].elements.mc1_IncludeInPIP = { "name": "attributes.mc1_IncludeInPIP__" + i, "label": "Send Monthly Statement?", "type": "field",  "renderer": "react-select", "options": [{"value": "true","label": "Yes"}, { "value": "false","label": "No"},], "fieldType": "text"};
        }

        return schema;

    }

    removeSecurityOption()
    {
        let to_remove = this.state.security_selector;

        let schema = this.state.data;      

        for(let i=0; i<schema.elements.security_selector.options.length; i++) {
            if(schema.elements.security_selector.options[i]['value']===to_remove) {
                schema.elements.security_selector.options.splice(i, 1);
            }
        }
        this.setState({ 
            data: schema, 
        });
        return to_remove;
    }

    removeMulticontactOption()
    {
        let to_remove = this.state.multicontact_selector;

        let schema = this.state.data;     

        for(let i=0; i<schema.elements.multicontact_selector.options.length; i++) {
            if(schema.elements.multicontact_selector.options[i]['value']===to_remove) {
                schema.elements.multicontact_selector.options.splice(i, 1);
            }
        }
        this.setState({ 
            data: schema, 
        });
        return to_remove;
    }

    scan(obj, key='currency', l='', found=[]) {
        var k;
        if (obj instanceof Object) {
            for (k in obj){
                if (obj.hasOwnProperty(k)){
                    //recursive call to scan property
                    this.scan( obj[k], key, l + '.' + k, found );  
                }
            }
        } else {
            if(obj==key) {
                found.push(l);
            }
        };
        return found;
    }

    validation_scan(obj, key='currency', l='', found=[]) {

        if(window.location.hostname=='localhost') {
            return true;
        }

        let ret = true;
        console.log('validating');
        $('input[validation="required"], .form-group.required input, .form-group.required select, select[validation="required"], textarea[validation="required"]').each(function(){
            console.log('.');
            if($(this).val()=='') {
                let label = $(this).parent().find('label').html();
                if(label) {
                    alertify.error(label.replace('*', '') + ' is required field');
                    ret = false;
                }
            }
        });
        return ret;
    }


    changeInJson (object) {

        function iter(o, p) {
            if (o && typeof o === 'object') {
                Object.keys(o).forEach(k => iter(o[k], p.concat(k)));
            } else {
                console.log('p=' + p);
            }
        }
    
        var result = [];
        iter(object, []);
        return result;
    }
    
    currency(amount, decimalCount = 2, decimal = ".", thousands = ",") 
    {

        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        
            const negativeSign = amount < 0 ? "-" : "";
        
            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;
        
            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
          } catch (e) {
            console.log(e)
          }
    }

    b2bChangeUpdateAction(b2b_value) 
    {
        if(b2b_value==='true') {
            $('.form-group-company').removeClass('d-none');
            $('.form-group-individual').addClass('d-none');
        } else {
            $('.form-group-company').addClass('d-none');
            $('.form-group-individual').removeClass('d-none');
        }
    }

    goToStep(s)
    {
        let validate_form = this.validation_scan();
        if(!validate_form) {
            return false;
        }

        // exception: form 3, returning from step 4 to step 3 should actually return step 2
        if(this.state.the_id==3 && this.state.step==4 && s==3) {
            s = 2;
        }

        localStorage.setItem('bo_form_data2', JSON.stringify(this.state.initial));
        localStorage.setItem('destroy_data', false);

        this.setState({ step: s });
        this.loadData(null, s);
    }

    goBack()
    {
        let s = this.state.step - 1;
        this.goToStep(s);
    }

    goToUrl(x) {
        window.location = x;
    }

    saveData()
    {
        localStorage.setItem('bo_form_data2', JSON.stringify(this.state.data));
    }

    parseNum(field)
    {
        if(typeof field === 'string') {
            field = field.replace(/,/g, "")
            // field = field.replace(',', '');
        }
        return Number(field);
    }

    getSecuritySubtypeOptions(l=null)
    {
        if(l==="Health & Education") {
            return [
                {"value":  "Nursing home", "label": "Nursing home"},
                {"value":  "Nursery", "label": "Nursery"}, 
                {"value":  "School", "label": "School"}, 
                {"value":  "Education Centre", "label": "Education Centre"}, 
            ]
        }

        if(l==="Industrial") {
            return [
                {"value":  "Storage / Distribution", "label": "Storage / Distribution"},
                {"value":  "Manufacturing - food", "label": "Manufacturing - food"}, 
                {"value":  "Manufacturing - none food", "label": "Manufacturing - none food"}, 
                {"value":  "Business Parks", "label": "Business Parks"}, 
                {"value":  "Waste transfer / scrap metal", "label": "Waste transfer / scrap metal"}, 
                {"value":  "Farm", "label": "Farm"},
                {"value":  "Workshop - repairs / maintenance", "label": "Workshop - repairs / maintenance"},
            ]
        }

        if(l==="Land") {
            return [
                {"value":  "Agricultural", "label": "Agricultural"}, 
                {"value":  "Car Park", "label": "Car Park"}, 
                {"value":  "Development - commercial / industrial", "label": "Development - commercial / industrial"}, 
                {"value":  "Development - mixed use", "label": "Development - mixed use"}, 
                {"value":  "Development - residential", "label": "Development - residential"}, 
                {"value":  "Quarry", "label": "Quarry"},
                {"value":  "Commercial yard", "label": "Commercial yard"},
                {"value":  "Land with planning permission", "label": "Land with planning permission"}, 
            ]
        }

        if(l==="Leisure") {
            return [
                {"value":  "Hotels / Guest house", "label": "Hotels / Guest house"}, 
                {"value":  "Public Houses / Drinking Establishment", "label": "Public Houses / Drinking Establishment"},
                {"value":  "Restaurant / Café", "label": "Restaurant / Café"},
                {"value":  "Sports facilities", "label": "Sports facilities"}, 
                {"value":  "Camping / Caravan / Lodge Park", "label": "Camping / Caravan / Lodge Park"}, 
                {"value":  "Entertainment", "label": "Entertainment"}, 
            ]
        }

        if(l==="Mixed Use") {
            return [
                {"value":  "Residential / Leisure", "label": "Residential / Leisure"}, 
                {"value":  "Residential / Offices", "label": "Residential / Offices"}, 
                {"value":  "Residential / Retail", "label": "Residential / Retail"},
            ]
        }

        if(l==="Offices") {
            return [
                {"value":  "Single tenant", "label": "Single tenant"}, 
                {"value":  "Office block", "label": "Office block"},
                {"value":  "Co-working / Serviced Office", "label": "Co-working / Serviced Office"},
                {"value":  "Owner occupied", "label": "Owner occupied"}, 
            ]
        }

        if(l==="Residential - let / rental") {
            return [
                {"value":  "House", "label": "House"}, 
                {"value":  "Flat - single", "label": "Flat - single"}, 
                {"value":  "HMO", "label": "HMO"}, 
                {"value":  "Student Accommodation", "label": "Student Accommodation"}, 
                {"value":  "Holiday Let / AirBnB", "label": "Holiday Let / AirBnB"},
                {"value":  "Farm / Country House", "label": "Farm / Country House"},
                {"value":  "Block of multi-let dwellings", "label": "Block of multi-let dwellings"}, 
            ]
        }

        if(l==="Residential - owner occupied") {
            return [
                {"value":  "House", "label": "House"},
                {"value":  "Apartment", "label": "Apartment"}, 
                {"value":  "Farm / Country House", "label": "Farm / Country House"}, 
            ]
        }

        if(l==="Retail") {
            return [
                {"value":  "Retail - shop", "label": "Retail - shop"},
                {"value":  "Retail - warehouse", "label": "Retail - warehouse"}, 
                {"value":  "Shopping Centres", "label": "Shopping Centres"}, 
                {"value":  "Garden Centre", "label": "Garden Centre"}, 
                {"value":  "Car showroom", "label": "Car showroom"}, 
            ]
        }

        return [
            // {"value":  "", "label": ""},   
        ];

        // return [
        //     {"value":  "Agricultural", "label": "Agricultural"}, 
        //     {"value":  "Apartment", "label": "Apartment"}, 
        //     {"value":  "Block of multi-let dwellings", "label": "Block of multi-let dwellings"}, 
        //     {"value":  "Business Parks", "label": "Business Parks"}, 
        //     {"value":  "Camping / Caravan / Lodge Park", "label": "Camping / Caravan / Lodge Park"}, 
        //     {"value":  "Car Park", "label": "Car Park"}, 
        //     {"value":  "Car showroom", "label": "Car showroom"}, 
        //     {"value":  "Commercial yard", "label": "Commercial yard"}, 
        //     {"value":  "Co-working / Serviced Office", "label": "Co-working / Serviced Office"}, 
        //     {"value":  "Development - commercial / industrial", "label": "Development - commercial / industrial"}, 
        //     {"value":  "Development - mixed use", "label": "Development - mixed use"}, 
        //     {"value":  "Development - residential", "label": "Development - residential"}, 
        //     {"value":  "Education Centre", "label": "Education Centre"}, 
        //     {"value":  "Entertainment", "label": "Entertainment"}, 
        //     {"value":  "Farm", "label": "Farm"}, 
        //     {"value":  "Farm / Country House", "label": "Farm / Country House"}, 
        //     {"value":  "Flat - single", "label": "Flat - single"}, 
        //     {"value":  "Garden Centre", "label": "Garden Centre"}, 
        //     {"value":  "HMO", "label": "HMO"}, 
        //     {"value":  "Holiday Let / AirBnB", "label": "Holiday Let / AirBnB"}, 
        //     {"value":  "Hotels / Guest house", "label": "Hotels / Guest house"}, 
        //     {"value":  "House", "label": "House"}, 
        //     {"value":  "Manufacturing - food", "label": "Manufacturing - food"}, 
        //     {"value":  "Manufacturing - none food", "label": "Manufacturing - none food"}, 
        //     {"value":  "Nursery", "label": "Nursery"}, 
        //     {"value":  "Nursing home", "label": "Nursing home"}, 
        //     {"value":  "Office block", "label": "Office block"}, 
        //     {"value":  "Owner occupied", "label": "Owner occupied"}, 
        //     {"value":  "Public Houses / Drinking Establishment", "label": "Public Houses / Drinking Establishment"}, 
        //     {"value":  "Quarry", "label": "Quarry"}, 
        //     {"value":  "Residential / Leisure", "label": "Residential / Leisure"}, 
        //     {"value":  "Residential / Offices", "label": "Residential / Offices"}, 
        //     {"value":  "Residential / Retail", "label": "Residential / Retail"}, 
        //     {"value":  "Restaurant / Café", "label": "Restaurant / Café"}, 
        //     {"value":  "Retail - shop", "label": "Retail - shop"}, 
        //     {"value":  "Retail - warehouse", "label": "Retail - warehouse"}, 
        //     {"value":  "School", "label": "School"}, 
        //     {"value":  "Shopping Centres", "label": "Shopping Centres"}, 
        //     {"value":  "Single tenant", "label": "Single tenant"}, 
        //     {"value":  "Sports facilities", "label": "Sports facilities"}, 
        //     {"value":  "Storage / Distribution", "label": "Storage / Distribution"}, 
        //     {"value":  "Student Accommodation", "label": "Student Accommodation"}, 
        //     {"value":  "Waste transfer / scrap metal", "label": "Waste transfer / scrap metal"}, 
        //     {"value":  "Workshop - repairs / maintenance", "label": "Workshop - repairs / maintenance"},  
        // ];

        
    }

    handleChange() {
    }

    render() {
    const { form_name, step, payment_profile1, payment_profile2, frequency, calc_advance_amount, calc_payments, calc_payments_2, loading} = this.state;
    return (
    <div>
        <Navbar />
        <div className="container mt-4">
            <div className="row">
                <div className="col-md-10">
                    <div className="dynamic-form-2">

                        <div className={ (true) ? 'row mb-5' : 'hidden' }>
                            <div className="col-12">
                                <div className={ (config().visible_quick_quote_btn) ? 'col-md-3' : 'hidden' }>
                                    <a className="btn btn-block btn-sm btn-outline-success" onClick={() => { this.goToStep(2) }}>Quick Quote</a>
                                </div>
                                <div className="mt-4">
                                    <h1>{ form_name }</h1>
                                </div>
                            </div>
                        </div>

                        {
                            loading ? <Loading></Loading> : null
                        }
                        <Form 
                        key ={'dynamicform'}
                        innerRef={p => (this.formik = p)}
                        onUpdate={(data, formik, ) => {

                            $('button').attr('disabled', false);

                            // shortcut referrence
                            let att = data.values.attributes;
                            let schema = this.state.data;

                            console.log('update triggered');
                            console.log(att)

                            att = removeMultipleMainApplicants(att, this.state.multicontact_selector);

                            if(this.state.schema_init===false) {
                                // initial update hook
                                let ls = JSON.parse( localStorage.getItem('term') );
                                for(let i=0; i<ls; i++) {
                                    if(typeof att['fixed' + i] === 'undefined' ) {
                                        att['fixed' + i] = 'Regular';
                                    }
                                }
                                this.setState({  schema_init: true  });
                            }

                            /* todo: this should be reimplemented ----- */
                            if(this.state.security_selector_set_value_to!=null) {
                                att.security_selector = this.state.security_selector_set_value_to;
                                this.setState({security_selector_set_value_to: null})
                            }
                            if(att.security_selector || att.security_selector==0) {
                                this.setState({security_selector: att.security_selector});
                                $('.security_element').addClass('d-none');
                                $('.security_element__' + att.security_selector).removeClass('d-none');
                            }
                            if(att.multicontact_selector || att.multicontact_selector==0) {
                                this.setState({multicontact_selector: att.multicontact_selector});
                                $('.multicontact_element').addClass('d-none');
                                $('.multicontact_element__' + att.multicontact_selector).removeClass('d-none');
                            }
                            /* to here --- */

                            // form 17 & form 29 
                            if(att.B2B) {
                                this.b2bChangeUpdateAction(att.B2B);
                            }

                            // income matching logic pass #1 
                            // "regular": "Regular", "every": "Every", "fixed": "Fixed"
                            let terms_total = parseInt(att.payment_profile1 + att.payment_profile2);
                            let monthly_amount = localStorage.getItem('monthly');
                            
                            // monthly_amount = 5000;
                            
                            // form 3/3 income matching 
                            if(terms_total && monthly_amount) {


                                let total_to_pay_regular = parseInt(terms_total) * parseFloat(monthly_amount);
                                let terms_regular = terms_total;

                                for(let i=0; i<terms_total; i++) { 
                                    let v = parseFloat(att['payments' + i]);
                                    if(att['fixed' + i] === 'Every') {
                                        // update subsequent entries
                                        for(let j=i; j<terms_total; j+=12) {
                                            att['fixed' + j] = 'Every';
                                            att['payments' + j] = v;
                                        }
                                    }
                                    if(att['fixed' + i] === 'Every' || att['fixed' + i] === 'Fixed') {
                                        total_to_pay_regular = total_to_pay_regular - v;
                                        terms_regular --;
                                    }
                                }

                                // income matching logic pass #2
                                for(let i=0; i<terms_total; i++) { 
                                    let v = att['payments' + i];
                                    if(att['fixed' + i] === 'Regular') {
                                        att['payments' + i] = this.currency(total_to_pay_regular / terms_regular);
                                    }
                                }
                            }


                            // form 3/1 vat = net price * 0.2
                            att.vat = att.net_price ? this.currency(this.parseNum(att.net_price) * 0.2) : 0;

                            // calculate total_cost_2: Net Price + VAT + Non Vatable Cost = Total Cost
                            let tc2_net_price = this.parseNum(att.net_price);
                            let tc2_vat = this.parseNum(att.vat);
                            let tc2_non_vatable_cost = this.parseNum(att.non_vatable_cost);
                            att.total_cost_2 = (!isNaN(tc2_net_price) && !isNaN(tc2_vat) && !isNaN(tc2_non_vatable_cost)) ? this.currency(tc2_net_price + tc2_vat + tc2_non_vatable_cost) : 0.00;


                            if(suggestion_load!=null) {
                                att.postcode = suggestion_load.CustomerAddress.PostCode ?? "";
                                att.mobile = suggestion_load.Mobile ?? "";
                                att.telephone = suggestion_load.Telephone ?? "";
                                att.ba1 = suggestion_load.CustomerAddress.Address1;
                                att.ba2 = suggestion_load.CustomerAddress.Address2;
                                att.ba3 = suggestion_load.CustomerAddress.Address3;
                                att.city = suggestion_load.CustomerAddress.Address4;
                                att.companyreg = suggestion_load.CustomerAddress.Website;
                                att.main_contact = (suggestion_load.Firstname ?? "") + " " + (suggestion_load.Surname ?? "")
                                // att.business_type = suggestion_load.
                                suggestion_load = null;
                            }

                            if(suggestion_load_source!=null) {
                                
                                att.SourceContact = suggestion_load_source.Contact;
                                att.SourceName = suggestion_load_source.SourceName;
                                att.SourceEmail = suggestion_load_source.Email;
                                att.SourceTel = suggestion_load_source.Telephone;        
                                att.Source = suggestion_load_source.SourceName;
                                if(typeof suggestion_load_source.SourceTypes[0] != 'undefined') {
                                    att.SourceType = suggestion_load_source.SourceTypes[0].SourceType;
                                } else {
                                    att.SourceType = null;
                                }
                                
                                suggestion_load_source = null;
                            }
                            
                            let net_price = this.parseNum(att.net_price);
                            let vat_2 = this.parseNum(att.vat_2); 
                            let road_fund_licence = this.parseNum(att.road_fund_licence);
                            let not_vatable_cost = this.parseNum(att.not_vatable_cost);
                            let plus_vat_1 = att.plus_vat_1;
                            if(net_price && plus_vat_1==="Yes") {
                                vat_2 = net_price * 0.2;
                              } else {
                                vat_2 = net_price * 0.0;
                              }
                            att.vat_2 = this.currency(vat_2);
                            att.total_cost = this.currency(net_price + this.parseNum(vat_2) + road_fund_licence + not_vatable_cost);

                            // calculate term
                            let pp1 = this.parseNum(att.payment_profile1);
                            let pp2 = this.parseNum(att.payment_profile2);
                            let frequency = att.frequency;
                            let freq_multiplier = 1;
                            let first_payment = moment(att.first_payment, "DD-MM-YYYY");
                            let first_payment_month_diff_ceil = Math.ceil(first_payment.diff(moment(), 'months', false));
                            if(frequency==="Quarterly") freq_multiplier = 3; // old val 3
                            if(frequency==="Half Year") freq_multiplier = 6; // old val 6
                            if(frequency==="Yearly") freq_multiplier = 12;   // old val 1
                            // att.term = (pp1>=0 && pp2>=0 && first_payment_month_diff_ceil>=0) ? (pp1 + pp2 + first_payment_month_diff_ceil) * freq_multiplier : 0;
                            att.term = (pp1>=0 && pp2>=0 && first_payment_month_diff_ceil>=0) ? (pp1 + pp2 + first_payment_month_diff_ceil ) * freq_multiplier : 0;

                            // att.term = att.term * freq_multiplier

                            this.setState({
                                'payment_profile1': pp1,
                                'payment_profile2': pp2,
                                'frequency': frequency,
                                'freq_multiplier': freq_multiplier,
                                'start_date': att.start_date
                            });

                            // localStorage.setItem('term', att.term );
                            localStorage.setItem('payment_profile1', pp1 );
                            localStorage.setItem('payment_profile2', pp2 );
                            localStorage.setItem('frequency', frequency );
                            localStorage.setItem('freq_multiplier', frequency );
                            localStorage.setItem('start_date', att.first_payment );

                            // calculate part exchange vat
                            let part_exchange = this.parseNum(att.part_exchange);
                            if(!part_exchange) part_exchange = 0;
                            let part_exchange_is_vat = att.part_exchange_plus_vat;
                            if(part_exchange_is_vat && part_exchange) {
                                att.part_exchange_vat = (part_exchange_is_vat==='Yes') ? this.parseNum(part_exchange * 0.2) : this.parseNum(part_exchange * 0.0);
                            } else {
                                att.part_exchange_vat = 0;
                            }
                            att.total_price = this.currency(att.part_exchange_vat + part_exchange);
                            att.part_exchange_vat = this.currency(att.part_exchange_vat);

                            let total_cost = this.parseNum(att.total_cost);
                            let part_exchange_total = this.parseNum(att.total_price);
                            let cash_deposit = this.parseNum(att.cash_deposit);
                            let dealer_deposit = this.parseNum(att.dealer_deposit);
                            let subsidy = this.parseNum(att.subsidy); 
                            let balloon = this.parseNum(att.balloon);

                            if(att.fund_vat === 'No') {
                                att.amount_financed = this.currency(this.parseNum(total_cost) - this.parseNum(att.vat_2) - this.parseNum(dealer_deposit) -  this.parseNum(part_exchange) - this.parseNum(cash_deposit) - this.parseNum(subsidy));
                            } else {
                                att.amount_financed = this.currency(total_cost - (part_exchange_total + cash_deposit + dealer_deposit) - subsidy /* - balloon */) ;
                            }

                            // bottom-calculator
                            let principal = this.parseNum(att.amount_financed);

                            let interest = this.parseNum(att.yield) / 100 / freq_multiplier; 

                            let _pp1 = principal / att.term * pp1;
                            let _pp2 = principal / att.term * pp2;

                            let x = Math.pow(1 + interest, pp2);

                            let monthly_temp = (_pp2*x*interest)/(x-1);
                            monthly_temp = (monthly_temp * pp2) + _pp1;

                            let monthly = monthly_temp / (att.term);

                            
                            localStorage.setItem('monthly', monthly);
                            att.income_payment = monthly;

                            this.setState({ 
                                calc_advance_amount: this.currency(this.parseNum(att.amount_financed)), 
                                calc_payments: this.currency(monthly),
                                calc_payments_2: this.currency(peregrine_calc_wrapper(att)),
                                calc_term: att.term
                            });
                            // set preview
                            $('.form-3-overview').html('Advance Amount: £' +  this.currency(this.parseNum(att.amount_financed)) + ' <br />Payments: £' + this.currency(monthly) +  ' <br />Term (' + att.frequency + '): ' + att.payment_profile1 + '+' + att.payment_profile2);


                            // form 9 sum up risk_totalcount //renamed to dynamicData3
                            att.dynamicData3 = this.parseNum(att.caseAssessor31 ?? 0) + this.parseNum(att.caseAssessor32 ?? 0) + this.parseNum(att.caseAssessor33 ?? 0) + this.parseNum(att.caseAssessor34 ?? 0) + this.parseNum(att.caseAssessor35 ?? 0);

                            // form 9 sum up risk_totalcount //renamed to caseAssessor76
                            att.caseAssessor73 = this.parseNum(att.caseAssessor68 ?? 0) + this.parseNum(att.caseAssessor69 ?? 0) + this.parseNum(att.caseAssessor70 ?? 0) + this.parseNum(att.caseAssessor71 ?? 0) + this.parseNum(att.caseAssessor72 ?? 0);

                            // update fee, cost of funds and margin (term required here)
                            let funder = att.funder;
                            let asset = att.funding_category;
                            let matrix = [
                                {
                                    'name': 'BNP Paribas',
                                    'data': [
                                        [1.25, 100, 100, 3.54, 3.54, 3.54, 3.75, 3.75, 3.75, 3.75, null, null, null],   // hard asset
                                        [1.25, 100, 100, 3.54, 3.54, 3.54, 3.75, 3.75, 3.75, 3.75, null, null, null],   // soft asset
                                    ]
                                },
                                {
                                    'name': 'Hitachi',
                                    'data': [
                                        [2.00, 100,  75, 3.34, 3.41, 3.45, 3.43, 3.48, 3.52, 3.57, null, null, null],
                                        [2.00, 100,  75, 3.34, 3.41, 3.45, 3.43, 3.48, 3.52, 3.57, null, null, null],
                                ]
                                },
                                {
                                    'name': 'De Lage Landen',
                                    'data': [
                                        [null, 100,  50, 4.04, 4.08, 4.03, 4.10, 4.16, 4.36, 4.40, 4.44, 4.48, 4.51],
                                        [null, 100,  50, 4.04, 4.08, 4.03, 4.10, 4.16, 4.36, 4.40, 4.44, 4.48, 4.51],
                                ]
                                },
                                {
                                    'name': 'Northridge',
                                    'data': [
                                        [3.00,   0,  10, 0.91, 0.88, 0.86, 0.86, 0.87, null, null, null, null, null],
                                        [null, null, null, null, null, null, null, null, null, null, null, null, null],
                                ]
                                },
                                {
                                    'name': 'Aldermore',
                                    'data': [
                                        [2.00, 100,  10, 3.30, 3.30, 3.30, 3.35, 3.35, 3.45, 3.55, null, null, null],
                                        [2.00, 200, 100, 4.30, 4.30, 4.30, 4.35, 4.35, 4.45, 4.55, null, null, null],
                                ]
                                }
                            ]
                            if(asset) {
                                let hard_soft_index = (asset==='Hard Asset') ? 0 : 1;
                                att.cost_of_funds = 0;
                                att.margin = 0;
                                matrix.forEach((element, index, array) => {
                                if(element.name===funder) {

                                    if(att.funder != this.state.previous_funder) {
                                        att.doc_fee = this.currency(element.data[hard_soft_index][1]);
                                        att.option_to_purchase_fee =  this.currency(element.data[hard_soft_index][2]);
                                    }

                                    if(att.term) {
                                        if(att.term>0 && att.term<=12)    att.cost_of_funds = element.data[hard_soft_index][3];
                                        else if(att.term>12 && att.term<=24)   att.cost_of_funds = element.data[hard_soft_index][4];
                                        else if(att.term>24 && att.term<=36)   att.cost_of_funds = element.data[hard_soft_index][5];
                                        else if(att.term>36 && att.term<=48)   att.cost_of_funds = element.data[hard_soft_index][6];
                                        else if(att.term>48 && att.term<=60)   att.cost_of_funds = element.data[hard_soft_index][7];
                                        else if(att.term>60 && att.term<=72)   att.cost_of_funds = element.data[hard_soft_index][8];
                                        else if(att.term>72 && att.term<=84)   att.cost_of_funds = element.data[hard_soft_index][9];
                                        else if(att.term>84 && att.term<=96)   att.cost_of_funds = element.data[hard_soft_index][10];
                                        else if(att.term>96 && att.term<=108)  att.cost_of_funds = element.data[hard_soft_index][11];
                                        else if(att.term>108 && att.term<=120) att.cost_of_funds = element.data[hard_soft_index][12];
                                        else att.cost_of_funds = 0;
                                        att.margin = att.yield - att.cost_of_funds;
                                    } 
                                }
                                });
                            }

                            // populate security sub-types
                            for(let i=0; i<50; i++) {
                                if(typeof att['SecurityType__' + i] != 'undefined') {
                                    schema.elements.security_multi_element.elements['security_details_' + i].elements['SecuritySubType'].options = this.getSecuritySubtypeOptions(att['SecurityType__' + i]);
                                } else {
                                    break;
                                }
                            }

                            this.setState({ 
                                previous_funder: att.funder,
                                data: schema
                            });

                            // doc fee to-do

                            // more
                            if(this.state.step==4) {
                                if(typeof data.values.attributes != 'undefined') {
                                    let dc = data.values.attributes.director_count;
                                    $('.director_2, .director_3, .director_4, .director_5').addClass('hidden');
                                    for(let i=1; i<=dc; i++) {
                                        $('.director_' + i).removeClass('hidden');
                                    }
                                }
                            }

                            // save state
                            // localStorage.setItem('bo_form_data2', JSON.stringify( { 'attributes': att}  ));

                        }}
                        onChange={() => console.log("test!")}
                        onSubmit={(data, formik) => { 

                            let confirmAction = true;
                            if(this.state.data.confirmation && this.state.data.confirmation===true) {
                                confirmAction = window.confirm("This form should not be submitted until receipt of the client signed variation agreement, by doing so you confirm this has been received");
                            }

                            if(!confirmAction) {
                                return false;
                            } 

                            let validate_form = this.validation_scan();
                            if(!validate_form) {
                                return false;
                            }
                            

                            // set additional defaults
                            if(this.state.data.defaults) {
                                for (let key in this.state.data.defaults) {
                                    data.attributes[key] = this.state.data.defaults[key];
                                }
                            }

                            data.attributes.form_id = this.state.the_id;

                            if(this.state.step == this.state.steps) {
                                let applicant_id = queryString.parse(this.props.location.search).applicant_id;
                                let customer_reference = queryString.parse(this.props.location.search).customer_reference;
                                let resp = boApiSendProposal(this.state.endpoint, data, formik, applicant_id, customer_reference);
                                // if(resp && resp.status==='error') {
                                //     alertify.error(resp.message);
                                //}
                            } else {
                                localStorage.setItem('destroy_data', false);
                                localStorage.setItem('bo_form_data2', JSON.stringify(data));
                                let c = this.state.step;
                                this.setState({ step: c + 1 });
                                this.loadData();
                            }
                        }}
                        validator={() => ({})}         
                        schema={this.state.data}
                        enableReinitialize={true} 
                        initialValues={ this.state.initial  }
                        ></Form>

                                               
                        <div className={ (step===2) ? '' : 'hidden' }>
                            <div className="card mb-4">
                                <div className="card-body">

                                
                                    <div className="row hidden">
                                        <div className="col-md-3">
                                            <label>Amount of loan</label>
                                            <input type='text' className='form-control' value={this.state.totalLoan} onChange={this.totalLoanChanged} />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Annual interest (%)</label>
                                            <input type='text' className='form-control' value={this.state.loanRate} onChange={this.loanRateChanged} />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Repayment period (Months)</label>
                                            <input type='text' className='form-control' value={this.state.periodsInAYear} onChange={this.periodsChanged} />
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <label>Advance Amount</label>
                                            <h4><strong>&pound;{ calc_advance_amount }</strong></h4>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Payments</label>
                                            <h4><strong>&pound;{ calc_payments }</strong></h4>
                                        </div>
                                        <div className="col-md-3">
                                            <label>Term ({frequency})</label>
                                            <h4><strong>{ payment_profile1 } + { payment_profile2 }</strong></h4>
                                        </div>
                                        <div className="col-md-3">
                                            <label>New Calc</label>
                                            <h4><strong>{ calc_payments_2 }</strong></h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3"><a className="btn btn-block btn-sm btn-outline-success" onClick={() => { this.goToStep(1) }}>Back to Equipment</a></div>
                                        <div className="col-md-3"><a className="btn btn-block btn-sm btn-outline-success" onClick={() => { this.goToStep(3) }}>Income Matching</a></div>
                                        <div className="col-md-2"><Link className="btn btn-block btn-sm btn-outline-success" to="/dash">Discard</Link></div>
                                        <div className="col-md-2"><a className="btn btn-block btn-sm btn-outline-success btn-calculator-progress" onClick={() => { this.saveData() }}>Save</a></div>
                                        <div className="col-md-2"><a className="btn btn-block btn-sm btn-success btn-calculator-progress" onClick={() => { this.goToStep(4) }}>Next</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
                                
}
}

export default DynamicFormApiWithSteps;
